import { _ as _extends } from '../../dist/extends-a2cb9f0c.esm.js';
import alpha from 'color-alpha';
import isHotkey from 'is-hotkey';
import { throttle, debounce as debounce$1 } from 'lodash-es';
import randomColor from 'randomcolor';
import React__default, { useMemo, useEffect, useState, useCallback, useRef } from 'react';
import { StyleSheet, View, useWindowDimensions, Dimensions, Platform } from 'react-native';
import { Transforms, Editor, Element as Element$1, Range, Point, Node, createEditor, Text, Path } from 'slate';
import { withHistory } from 'slate-history';
import { Editable, useSlateStatic, ReactEditor, useSelected, useFocused, useSlate, withReact, Slate } from 'slate-react';
import { A as AppAssets } from '../../dist/index-3256db5b.esm.js';
import { A as AppMenuOptions, a as AppMultiSelectionOptions, C as CheckItem } from '../../dist/MultipleSelectionComponent-126552a6.esm.js';
import { A as AppPopup } from '../../dist/index-f89540e5.esm.js';
import { A as AppText, a as AppIcon } from '../../dist/index-6b88191c.esm.js';
import { u as useQuantumEditor, Q as QuantumEditorProvider } from '../../dist/AnnotationToolBarModalComponents-4a9cb8d5.esm.js';
import { u as useTheme } from '../../dist/useTheme-90e8e2c2.esm.js';
import { a as AppSpinner, A as AppActivityIndicator } from '../../dist/index-2b5eefb0.esm.js';
import { A as AppAvatarList } from '../../dist/index-3ac9d0f0.esm.js';
import { A as AppLabelCountIcon } from '../../dist/index-b073e388.esm.js';
import { A as AppTrackSlider } from '../../dist/index-182c2016.esm.js';
import ReactDOM from 'react-dom';
import { useRemoteCursorStates } from '@slate-yjs/react';
import { relativeRangeToSlateRange } from '@slate-yjs/core';
import { U as Utilities } from '../../dist/index-e2cfb1e9.esm.js';
import { A as AppAvatar } from '../../dist/index-ec953df8.esm.js';
import { Q as QuantumConfig, g as getTextAroundIndex } from '../../dist/index-72ff421b.esm.js';
import { g as generateRowId } from '../../dist/index-b141c75b.esm.js';
import { m as matchEntityLabelWithEntityStyle } from '../../dist/utility-e54b20cc.esm.js';
import { A as AppTooltip } from '../../dist/index-3fb48509.esm.js';
import { A as AppMultiSwitchOptions } from '../../dist/MultipleSwitchSelectionComponent-88d36c19.esm.js';
import { A as AppTextChip } from '../../dist/index-1487832e.esm.js';
import { A as AppList } from '../../dist/index-74f0c7d2.esm.js';
import { debounce } from 'lodash';
import { d as dateConverter } from '../../dist/dateConverter-9a5bb186.esm.js';
import isUrl from 'is-url';
import { A as AppTextInput } from '../../dist/index-c2a07f56.esm.js';
import { A as AppSwitch } from '../../dist/index-dbc9bff8.esm.js';
import { A as AppDropDown } from '../../dist/index-db6cb3b9.esm.js';
import { A as AppModal } from '../../dist/index-9c3f5cad.esm.js';
import { A as AppFadeView } from '../../dist/index-948166a0.esm.js';
import imageExtensions from 'image-extensions';
import axios from 'axios';
import { A as AppPlaceholderView } from '../../dist/index-c374fb53.esm.js';
import 'escape-html';
import { A as AnnotationToolBarAddIcon } from '../../dist/AnnotationToolBarAddIcon-8fcc74c6.esm.js';
import { jsx } from 'slate-hyperscript';
import '@fortawesome/pro-light-svg-icons/faAdjust';
import '@fortawesome/pro-light-svg-icons/faAlignCenter';
import '@fortawesome/pro-light-svg-icons/faAlignLeft';
import '@fortawesome/pro-light-svg-icons/faAlignRight';
import '@fortawesome/pro-light-svg-icons/faArrowCircleRight';
import '@fortawesome/pro-light-svg-icons/faArrowSquareLeft';
import '@fortawesome/pro-light-svg-icons/faArrowToRight';
import '@fortawesome/pro-light-svg-icons/faBan';
import '@fortawesome/pro-light-svg-icons/faBars';
import '@fortawesome/pro-light-svg-icons/faBell';
import '@fortawesome/pro-light-svg-icons/faBezierCurve';
import '@fortawesome/pro-light-svg-icons/faBold';
import '@fortawesome/pro-light-svg-icons/faBookOpen';
import '@fortawesome/pro-light-svg-icons/faBookReader';
import '@fortawesome/pro-light-svg-icons/faBookmark';
import '@fortawesome/pro-light-svg-icons/faBooks';
import '@fortawesome/pro-light-svg-icons/faBracketsCurly';
import '@fortawesome/pro-light-svg-icons/faBrain';
import '@fortawesome/pro-light-svg-icons/faHeadSideBrain';
import '@fortawesome/pro-light-svg-icons/faBrowser';
import '@fortawesome/pro-light-svg-icons/faCalendarDay';
import '@fortawesome/pro-light-svg-icons/faCalendarEdit';
import '@fortawesome/pro-light-svg-icons/faFileChartLine';
import '@fortawesome/pro-light-svg-icons/faChartColumn';
import '@fortawesome/pro-light-svg-icons/faChartNetwork';
import '@fortawesome/pro-light-svg-icons/faCheckCircle';
import '@fortawesome/pro-light-svg-icons/faChevronDoubleUp';
import '@fortawesome/pro-light-svg-icons/faChevronDown';
import '@fortawesome/pro-light-svg-icons/faChevronLeft';
import '@fortawesome/pro-light-svg-icons/faScannerTouchscreen';
import '@fortawesome/pro-light-svg-icons/faChevronRight';
import '@fortawesome/pro-light-svg-icons/faChevronUp';
import '@fortawesome/pro-light-svg-icons/faCircle';
import '@fortawesome/pro-light-svg-icons/faClipboard';
import '@fortawesome/pro-light-svg-icons/faClipboardListCheck';
import '@fortawesome/pro-light-svg-icons/faSparkles';
import '@fortawesome/pro-light-svg-icons/faClock';
import '@fortawesome/pro-light-svg-icons/faClone';
import '@fortawesome/pro-light-svg-icons/faCloudDownload';
import '@fortawesome/pro-light-svg-icons/faCloudUpload';
import '@fortawesome/pro-light-svg-icons/faCode';
import '@fortawesome/pro-light-svg-icons/faCodeMerge';
import '@fortawesome/pro-light-svg-icons/faCog';
import '@fortawesome/pro-light-svg-icons/faCommentAltLines';
import '@fortawesome/pro-light-svg-icons/faCommentLines';
import '@fortawesome/pro-light-svg-icons/faCommentsAlt';
import '@fortawesome/pro-light-svg-icons/faCompressAlt';
import '@fortawesome/pro-light-svg-icons/faCopy';
import '@fortawesome/pro-light-svg-icons/faCreditCard';
import '@fortawesome/pro-light-svg-icons/faDatabase';
import '@fortawesome/pro-light-svg-icons/faDollarSign';
import '@fortawesome/pro-light-svg-icons/faEdit';
import '@fortawesome/pro-light-svg-icons/faEllipsisH';
import '@fortawesome/pro-light-svg-icons/faEllipsisV';
import '@fortawesome/pro-light-svg-icons/faEnvelopeOpenText';
import '@fortawesome/pro-light-svg-icons/faEraser';
import '@fortawesome/pro-light-svg-icons/faExchangeAlt';
import '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import '@fortawesome/pro-light-svg-icons/faExpandAlt';
import '@fortawesome/pro-light-svg-icons/faExpandWide';
import '@fortawesome/pro-light-svg-icons/faEye';
import '@fortawesome/pro-light-svg-icons/faEyeSlash';
import '@fortawesome/pro-light-svg-icons/faFile';
import '@fortawesome/pro-light-svg-icons/faFileAlt';
import '@fortawesome/pro-light-svg-icons/faFileCode';
import '@fortawesome/pro-light-svg-icons/faFileCsv';
import '@fortawesome/pro-light-svg-icons/faFileExcel';
import '@fortawesome/pro-light-svg-icons/faFileExport';
import '@fortawesome/pro-light-svg-icons/faFileImport';
import '@fortawesome/pro-light-svg-icons/faFileInvoiceDollar';
import '@fortawesome/pro-light-svg-icons/faFilePdf';
import '@fortawesome/pro-light-svg-icons/faFilePowerpoint';
import '@fortawesome/pro-light-svg-icons/faFileSignature';
import '@fortawesome/pro-light-svg-icons/faFileUpload';
import '@fortawesome/pro-light-svg-icons/faFileWord';
import '@fortawesome/pro-light-svg-icons/faFolder';
import '@fortawesome/pro-light-svg-icons/faFont';
import '@fortawesome/pro-light-svg-icons/faGameBoardAlt';
import '@fortawesome/pro-light-svg-icons/faGlobeEurope';
import '@fortawesome/pro-light-svg-icons/faGlobePointer';
import '@fortawesome/pro-light-svg-icons/faGripLinesVertical';
import '@fortawesome/pro-light-svg-icons/faGripVertical';
import '@fortawesome/pro-light-svg-icons/faH1';
import '@fortawesome/pro-light-svg-icons/faH2';
import '@fortawesome/pro-light-svg-icons/faHashtag';
import '@fortawesome/pro-light-svg-icons/faHighlighter';
import '@fortawesome/pro-light-svg-icons/faHistory';
import '@fortawesome/pro-light-svg-icons/faHomeAlt';
import '@fortawesome/pro-light-svg-icons/faImage';
import '@fortawesome/pro-light-svg-icons/faInbox';
import '@fortawesome/pro-light-svg-icons/faIndent';
import '@fortawesome/pro-light-svg-icons/faInfoCircle';
import '@fortawesome/pro-light-svg-icons/faItalic';
import '@fortawesome/pro-light-svg-icons/faKeyboard';
import '@fortawesome/pro-light-svg-icons/faLanguage';
import '@fortawesome/pro-light-svg-icons/faLaptopCode';
import '@fortawesome/pro-light-svg-icons/faLayerGroup';
import '@fortawesome/pro-light-svg-icons/faLightbulbExclamation';
import '@fortawesome/pro-light-svg-icons/faLink';
import '@fortawesome/pro-light-svg-icons/faListOl';
import '@fortawesome/pro-light-svg-icons/faListUl';
import '@fortawesome/pro-light-svg-icons/faLock';
import '@fortawesome/pro-light-svg-icons/faLockOpen';
import '@fortawesome/pro-light-svg-icons/faMeteor';
import '@fortawesome/pro-light-svg-icons/faMicrophone';
import '@fortawesome/pro-light-svg-icons/faMoneyCheckAlt';
import '@fortawesome/pro-light-svg-icons/faNetworkWired';
import '@fortawesome/pro-light-svg-icons/faPaintRoller';
import '@fortawesome/pro-light-svg-icons/faPaperPlaneTop';
import '@fortawesome/pro-light-svg-icons/faPen';
import '@fortawesome/pro-light-svg-icons/faPlanetRinged';
import '@fortawesome/pro-light-svg-icons/faPlus';
import '@fortawesome/pro-light-svg-icons/faPlusCircle';
import '@fortawesome/pro-light-svg-icons/faPowerOff';
import '@fortawesome/pro-light-svg-icons/faQuestion';
import '@fortawesome/pro-light-svg-icons/faQuestionCircle';
import '@fortawesome/pro-light-svg-icons/faQuoteLeft';
import '@fortawesome/pro-light-svg-icons/faRedo';
import '@fortawesome/pro-light-svg-icons/faReply';
import '@fortawesome/pro-light-svg-icons/faRocketLaunch';
import '@fortawesome/pro-light-svg-icons/faSatelliteDish';
import '@fortawesome/pro-light-svg-icons/faScrubber';
import '@fortawesome/pro-light-svg-icons/faSearch';
import '@fortawesome/pro-light-svg-icons/faSearchMinus';
import '@fortawesome/pro-light-svg-icons/faSearchPlus';
import '@fortawesome/pro-light-svg-icons/faShareAlt';
import '@fortawesome/pro-light-svg-icons/faSignOut';
import '@fortawesome/pro-light-svg-icons/faSlidersV';
import '@fortawesome/pro-light-svg-icons/faSlidersVSquare';
import '@fortawesome/pro-light-svg-icons/faSpinner';
import '@fortawesome/pro-light-svg-icons/faStopCircle';
import '@fortawesome/pro-light-svg-icons/faStream';
import '@fortawesome/pro-light-svg-icons/faStrikethrough';
import '@fortawesome/pro-light-svg-icons/faSync';
import '@fortawesome/pro-light-svg-icons/faTag';
import '@fortawesome/pro-light-svg-icons/faTerminal';
import '@fortawesome/pro-light-svg-icons/faThumbsDown';
import '@fortawesome/pro-light-svg-icons/faThumbsUp';
import '@fortawesome/pro-light-svg-icons/faThumbtack';
import '@fortawesome/pro-light-svg-icons/faTimes';
import '@fortawesome/pro-light-svg-icons/faTimesCircle';
import '@fortawesome/pro-light-svg-icons/faTrash';
import '@fortawesome/pro-light-svg-icons/faTypewriter';
import '@fortawesome/pro-light-svg-icons/faUnderline';
import '@fortawesome/pro-light-svg-icons/faUndo';
import '@fortawesome/pro-light-svg-icons/faUnlink';
import '@fortawesome/pro-light-svg-icons/faUser';
import '@fortawesome/pro-light-svg-icons/faUserCircle';
import '@fortawesome/pro-light-svg-icons/faUserLock';
import '@fortawesome/pro-light-svg-icons/faUserBeardBolt';
import '@fortawesome/pro-light-svg-icons/faUserRobot';
import '@fortawesome/pro-light-svg-icons/faUserSecret';
import '@fortawesome/pro-light-svg-icons/faUserAstronaut';
import '@fortawesome/pro-light-svg-icons/faUserShield';
import '@fortawesome/pro-light-svg-icons/faUsers';
import '@fortawesome/pro-light-svg-icons/faUsersCog';
import '@fortawesome/pro-light-svg-icons/faVial';
import '@fortawesome/pro-light-svg-icons/faWaveSquare';
import '@fortawesome/pro-light-svg-icons/faWifiSlash';
import '@fortawesome/pro-light-svg-icons/faWindowMinimize';
import '@fortawesome/pro-light-svg-icons/faChartBar';
import '@fortawesome/pro-light-svg-icons/faSlidersH';
import '@fortawesome/pro-light-svg-icons/faPageBreak';
import '@fortawesome/pro-light-svg-icons/faServer';
import '@fortawesome/pro-light-svg-icons/faTools';
import '@fortawesome/pro-light-svg-icons/faAnalytics';
import '@fortawesome/pro-light-svg-icons/faTrophy';
import '@fortawesome/pro-light-svg-icons/faDice';
import '@fortawesome/pro-light-svg-icons/faSwords';
import '@fortawesome/pro-light-svg-icons/faBoxingGlove';
import '@fortawesome/pro-light-svg-icons/faRandom';
import '@fortawesome/pro-light-svg-icons/faVideoPlus';
import '@fortawesome/pro-light-svg-icons/faFileAudio';
import '@fortawesome/pro-light-svg-icons/faMagic';
import '@fortawesome/pro-light-svg-icons/faSitemap';
import '@fortawesome/pro-light-svg-icons/faFiles';
import '@fortawesome/pro-light-svg-icons/faUserShakespeare';
import '@fortawesome/pro-light-svg-icons/faUserPilot';
import '@fortawesome/pro-light-svg-icons/faUserPilotTie';
import '@fortawesome/pro-light-svg-icons/faUserRobotXmarks';
import '@fortawesome/pro-light-svg-icons/faUserVisor';
import '@fortawesome/pro-light-svg-icons/faUserNinja';
import '@fortawesome/pro-light-svg-icons/faUserGear';
import '@fortawesome/pro-light-svg-icons/faArrowTurnDownRight';
import '@fortawesome/pro-light-svg-icons/faTriangleExclamation';
import '@fortawesome/pro-light-svg-icons/faMessageBot';
import '@fortawesome/pro-light-svg-icons/faVolume';
import '@fortawesome/pro-light-svg-icons/faVolumeSlash';
import '@fortawesome/pro-light-svg-icons/faImages';
import '@fortawesome/pro-light-svg-icons/faSwordLaser';
import '@fortawesome/pro-light-svg-icons/faSwordsLaser';
import '@fortawesome/pro-light-svg-icons/faHelmetBattle';
import '@fortawesome/pro-light-svg-icons/faUpRightAndDownLeftFromCenter';
import '@fortawesome/pro-light-svg-icons/faDownLeftAndUpRightToCenter';
import '@fortawesome/pro-light-svg-icons/faFileSpreadsheet';
import '@fortawesome/pro-light-svg-icons/faPresentationScreen';
import '@fortawesome/pro-light-svg-icons/faFileInvoice';
import '@fortawesome/pro-light-svg-icons/faChalkboardTeacher';
import '@fortawesome/pro-light-svg-icons/faCircleDollar';
import '@fortawesome/pro-light-svg-icons/faPersonFairy';
import '@fortawesome/pro-light-svg-icons/faCubes';
import '@fortawesome/pro-light-svg-icons/faUserHeadset';
import '@fortawesome/pro-light-svg-icons/faPalette';
import '@fortawesome/pro-light-svg-icons/faChartMixed';
import '@fortawesome/pro-light-svg-icons/faBrainCircuit';
import '@fortawesome/pro-light-svg-icons/faImageLandscape';
import '@fortawesome/pro-light-svg-icons/faHexagonPlus';
import '@fortawesome/pro-light-svg-icons/faPrintMagnifyingGlass';
import '@fortawesome/pro-light-svg-icons/faShieldHalved';
import '@fortawesome/pro-light-svg-icons/faDiagramSubtask';
import '@fortawesome/pro-light-svg-icons/faHandshake';
import '@fortawesome/pro-light-svg-icons/faBullhorn';
import '@fortawesome/pro-light-svg-icons/faCogs';
import '@fortawesome/pro-light-svg-icons/faHeadset';
import '@fortawesome/pro-light-svg-icons/faMicroscope';
import '@fortawesome/pro-light-svg-icons/faScaleBalanced';
import '@fortawesome/pro-light-svg-icons/faTruck';
import '@fortawesome/pro-light-svg-icons/faBuildings';
import '@fortawesome/pro-light-svg-icons/faInputText';
import '@fortawesome/pro-light-svg-icons/faProjectDiagram';
import '@fortawesome/pro-light-svg-icons/faPaperclip';
import '@fortawesome/pro-light-svg-icons/faFileVideo';
import '@fortawesome/pro-light-svg-icons/faCircleChevronUp';
import '@fortawesome/pro-light-svg-icons/faCircleChevronDown';
import '@fortawesome/pro-light-svg-icons/faUnlockKeyhole';
import '@fortawesome/pro-light-svg-icons/faChartScatter3d';
import '@fortawesome/pro-light-svg-icons/faSidebar';
import '@fortawesome/pro-light-svg-icons/faGlobe';
import '@fortawesome/pro-light-svg-icons/faSquare';
import '@fortawesome/pro-light-svg-icons/faSquareRss';
import '@fortawesome/pro-light-svg-icons/faAsterisk';
import '@fortawesome/pro-light-svg-icons/faCircleUser';
import '@fortawesome/pro-light-svg-icons/faUpFromBracket';
import '@fortawesome/pro-light-svg-icons/faHouseLock';
import '@fortawesome/pro-light-svg-icons/faXmarkToSlot';
import '@fortawesome/pro-light-svg-icons/faRobot';
import '@fortawesome/pro-light-svg-icons/faMagicWandSparkles';
import '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import '@fortawesome/pro-light-svg-icons/faBook';
import '@fortawesome/pro-light-svg-icons/faImagePolaroid';
import '@fortawesome/pro-light-svg-icons/faVideo';
import '@fortawesome/pro-light-svg-icons/faCube';
import '@fortawesome/pro-light-svg-icons/faToolbox';
import '@fortawesome/pro-light-svg-icons/faTimer';
import '@fortawesome/pro-light-svg-icons/faThoughtBubble';
import '@fortawesome/pro-light-svg-icons/faSwap';
import '@fortawesome/pro-light-svg-icons/faFloppyDisk';
import '@fortawesome/pro-light-svg-icons/faWandMagicSparkles';
import '@fortawesome/pro-light-svg-icons/faXmark';
import '@fortawesome/pro-light-svg-icons/faFileVector';
import '@fortawesome/pro-light-svg-icons/faWrench';
import '@fortawesome/pro-light-svg-icons/faVectorPolygon';
import '@fortawesome/pro-light-svg-icons/faClose';
import '@fortawesome/pro-light-svg-icons/faCircleXmark';
import '@fortawesome/pro-light-svg-icons/faCloud';
import '@fortawesome/pro-light-svg-icons/faPlanetMoon';
import '@fortawesome/pro-light-svg-icons/faListCheck';
import '@fortawesome/pro-light-svg-icons/faUnlock';
import '@fortawesome/pro-light-svg-icons/faCheck';
import '@fortawesome/pro-light-svg-icons/faCirclePlus';
import '@fortawesome/pro-light-svg-icons/faCircleMinus';
import '@fortawesome/pro-light-svg-icons/faWandSparkles';
import '@fortawesome/pro-light-svg-icons/faHardDrive';
import '@fortawesome/pro-light-svg-icons/faLightbulb';
import '../../dist/AppButton-a3bdb006.esm.js';
import '../../dist/index-a9a6637c.esm.js';
import 'expo-linear-gradient';
import 'react-i18next';
import '../../dist/index-0ee62650.esm.js';
import '@fortawesome/react-native-fontawesome';
import 'react-native-popable';
import 'markdown-it';
import 'mermaid';
import 'url';
import 'highlight.js';
import '@mermaid-js/mermaid-zenuml/dist/mermaid-zenuml.core.mjs';
import 'react-native-markdown-display';
import '../../dist/index-2277a72b.esm.js';
import '../../dist/index-ce6ef2b2.esm.js';
import '../../dist/AppSubmitButton-2e6a9268.esm.js';
import 'formik';
import '../../dist/AppFormField-e5fa211c.esm.js';
import '../../dist/AppFormPicker-04baca06.esm.js';
import '../../dist/index-b3be2636.esm.js';
import '../../dist/AppBaseScreen-6f697c5c.esm.js';
import 'react-native-toast-notifications';
import '../../dist/index-88946c45.esm.js';
import '../../dist/index-5ae71f5a.esm.js';
import 'prop-types';
import 'qs';
import 'yup';
import 'rc-slider';
import 'yjs';
import 'y-protocols/awareness.js';
import 'y-websocket';
import 'react-tooltip';
import 'dayjs';
import 'dayjs/plugin/customParseFormat';
import '@react-native-picker/picker';
import '../../dist/genericStyles-b9567994.esm.js';

const _listData = [{
  id: "bd7acbea-c1b1-46c2-aed5-3ad53abb28ba",
  title: "First Item",
  checked: true
}, {
  id: "3ac68afc-c605-48d3-a4f8-fbd91aa97f63",
  title: "Second Item",
  checked: false
}, {
  id: "58694a0f-3da1-471f-bd96-145571e29d72",
  title: "Third Item",
  checked: true
}, {
  id: "58694a0f-3da1-471f-bd96-145571e292",
  title: "Fourth Item",
  checked: true
}];
const imageData = {
  url: "https://picsum.photos/40/40"
};
const optionsData = [{
  isNavigation: true,
  icon: AppAssets.icons.trainAI,
  onPress: opt => {
    console.log("The item has been pressed", opt);
  },
  isBackHidden: true,
  OptionMenuComponent: /*#__PURE__*/React__default.createElement(AppMenuOptions, {
    shouldMenuProvideContext: false,
    options: [{
      isNavigation: true,
      icon: AppAssets.icons.redo,
      onPress: opt => {
        console.log("The item has been pressed", opt);
      },
      uid: "REDO",
      label: "Test selection",
      children: AppMultiSelectionOptions,
      subOptions: [{
        id: "bd7acbea-c1b1-46c2-aed5-3ad53abb28ba",
        title: "First Item",
        checked: true,
        uid: "REDO-1"
      }, {
        id: "3ac68afc-c605-48d3-a4f8-fbd91aa97f63",
        title: "Second Item",
        checked: false,
        uid: "REDO-1"
      }, {
        id: "58694a0f-3da1-471f-bd96-145571e29d72",
        title: "Third Item",
        checked: true,
        uid: "REDO-1"
      }]
    }]
  }),
  OptionMenuFooter: /*#__PURE__*/React__default.createElement(AppPopup, {
    btnTitle: "Add new intent",
    btnBackgroundColor: "grey",
    icon: AppAssets.icons.add_icon,
    isTriggerIcon: false,
    iconColor: "green"
  }, /*#__PURE__*/React__default.createElement(AppText, null, " This is the menu Footer")),
  uid: "INTENT",
  label: "Test custom component",
  subOptions: [],
  children: AppMultiSelectionOptions
}, {
  isNavigation: true,
  icon: AppAssets.icons.redo,
  onPress: opt => {
    console.log("The item has been pressed", opt);
  },
  uid: "REDO",
  label: "Test selection",
  children: AppMultiSelectionOptions,
  subOptions: [{
    id: "bd7acbea-c1b1-46c2-aed5-3ad53abb28ba",
    title: "First Item",
    checked: true,
    uid: "REDO"
  }, {
    id: "3ac68afc-c605-48d3-a4f8-fbd91aa97f63",
    title: "Second Item",
    checked: false,
    uid: "REDO"
  }, {
    id: "58694a0f-3da1-471f-bd96-145571e29d72",
    title: "Third Item",
    checked: true,
    uid: "REDO"
  }]
}];
const multiSelectionData = [
// this is the parent or 'item'
{
  category: "ner",
  id: 0,
  name: "Place"
  // these are the children or 'sub items'
}, {
  name: "Time",
  id: 17,
  category: "ner"
}, {
  name: "Person",
  id: 13,
  category: "ner"
}, {
  name: "Hearing issue",
  id: 14,
  category: "intent"
}, {
  name: "Hearing tactic",
  id: 15,
  category: "intent"
}, {
  name: "Solution",
  id: 16,
  category: "intent"
}];
const flatOptionsData = [{
  isNavigation: true,
  icon: AppAssets.icons.trainAI,
  onPress: opt => {
    console.log("The item has been pressed", opt);
  },
  uid: "INTENT",
  label: "Set intent",
  children: AppMultiSelectionOptions
}, {
  isNavigation: false,
  icon: AppAssets.icons.redo,
  onPress: opt => {
    console.log("The item has been pressed", opt);
  },
  uid: "REDO",
  label: "Redo",
  children: /*#__PURE__*/React__default.createElement(AppText, null, "Test 2")
}];
const tagsData = ["My tag 1", "My Tag 2"];
const namesData = ["Aayla Secura", "Adi Gallia", "Admiral Dodd Rancit", "Admiral Firmus Piett", "Admiral Gial Ackbar", "Admiral Ozzel", "Admiral Raddus", "Admiral Terrinald Screed", "Admiral Trench", "Admiral U.O. Statura", "Agen Kolar", "Agent Kallus", "Aiolin and Morit Astarte", "Aks Moe", "Almec", "Alton Kastle", "Amee", "AP-5", "Armitage Hux", "Artoo", "Arvel Crynyd", "Asajj Ventress", "Aurra Sing", "AZI-3", "Bala-Tik", "Barada", "Bargwill Tomder", "Baron Papanoida", "Barriss Offee", "Baze Malbus", "Bazine Netal", "BB-8", "BB-9E", "Ben Quadinaros", "Berch Teller", "Beru Lars", "Bib Fortuna", "Biggs Darklighter", "Black Krrsantan", "Bo-Katan Kryze", "Boba Fett", "Bobbajo", "Bodhi Rook", "Borvo the Hutt", "Boss Nass", "Bossk", "Breha Antilles-Organa", "Bren Derlin", "Brendol Hux", "BT-1", "C-3PO", "C1-10P", "Cad Bane", "Caluan Ematt", "Captain Gregor", "Captain Phasma", "Captain Quarsh Panaka", "Captain Rex", "Carlist Rieekan", "Casca Panzoro", "Cassian Andor", "Cassio Tagge", "Cham Syndulla", "Che Amanwe Papanoida", "Chewbacca", "Chi Eekway Papanoida", "Chief Chirpa", "Chirrut Îmwe", "Ciena Ree", "Cin Drallig", "Clegg Holdfast", "Cliegg Lars", "Coleman Kcaj", "Coleman Trebor", "Colonel Kaplan", "Commander Bly", "Commander Cody (CC-2224)", "Commander Fil (CC-3714)", "Commander Fox", "Commander Gree", "Commander Jet", "Commander Wolffe", "Conan Antonio Motti", "Conder Kyl", "Constable Zuvio", "Cordé", "Cpatain Typho", "Crix Madine", "Cut Lawquane", "Dak Ralter", "Dapp", "Darth Bane", "Darth Maul", "Darth Tyranus", "Daultay Dofine", "Del Meeko", "Delian Mors", "Dengar", "Depa Billaba", "Derek Klivian", "Dexter Jettster", "Dineé Ellberger", "DJ", "Doctor Aphra", "Doctor Evazan", "Dogma", "Dormé", "Dr. Cylo", "Droidbait", "Droopy McCool", "Dryden Vos", "Dud Bolt", "Ebe E. Endocott", "Echuu Shen-Jon", "Eeth Koth", "Eighth Brother", "Eirtaé", "Eli Vanto", "Ellé", "Ello Asty", "Embo", "Eneb Ray", "Enfys Nest", "EV-9D9", "Evaan Verlaine", "Even Piell", "Ezra Bridger", "Faro Argyus", "Feral", "Fifth Brother", "Finis Valorum", "Finn", "Fives", "FN-1824", "FN-2003", "Fodesinbeed Annodue", "Fulcrum", "FX-7"];
const textData = ["First Item", "Second Item", "Third Item", "Fourth Item", "Fifth Item", "Sixth Item"];
const _menuItems2 = [{
  screenName: "Parse",
  icon: AppAssets.icons.home,
  initialRouteName: "Parse"
}, {
  screenName: "Training",
  icon: AppAssets.icons.history,
  initialRouteName: "Training"
}, {
  screenName: "Settings",
  icon: AppAssets.icons.history,
  initialRouteName: "Settings"
}];
const _menuItems = [{
  screenName: "Parse",
  icon: AppAssets.icons.home,
  initialRouteName: "Parse",
  options: [{
    screenLabel: "Parse NER only",
    screenName: "Parse",
    id: "122344",
    icon: AppAssets.icons.home
  }, {
    screenLabel: "Parse Intent only",
    screenName: "Parse",
    id: "122346",
    icon: AppAssets.icons.paintRoller
  }, {
    screenLabel: "Parse All",
    screenName: "Parse",
    id: "1223455667",
    icon: AppAssets.icons.fullscreen
  }]
}, {
  screenName: "Training",
  icon: AppAssets.icons.history,
  initialRouteName: "Training",
  options: [{
    screenLabel: "Train intent",
    screenName: "Training",
    id: "242356366",
    icon: AppAssets.icons.home
  }, {
    screenLabel: "Train NER",
    screenName: "Training",
    id: "32423y865932",
    icon: AppAssets.icons.home
  }]
}, {
  screenName: "Settings",
  icon: AppAssets.icons.history,
  initialRouteName: "Settings"
}];
var mocked_data = {
  _listData,
  imageData,
  namesData,
  optionsData,
  textData,
  flatOptionsData,
  tagsData,
  _menuItems,
  _menuItems2,
  multiSelectionData
};

const Portal = _ref => {
  let {
    children
  } = _ref;
  return typeof document === "object" ? /*#__PURE__*/ReactDOM.createPortal(children, document.body) : null;
};

const QuantumAutoCompletionPortal = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    chars,
    index
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Portal, null, /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    style: {
      top: "-9999px",
      left: "-9999px",
      position: "absolute",
      zIndex: 1,
      padding: "3px",
      background: "white",
      borderRadius: 4,
      boxShadow: "0 1px 5px rgba(0,0,0,.2)"
    }
  }, chars.map((char, i) => /*#__PURE__*/React__default.createElement("div", {
    key: char,
    style: {
      padding: "1px 3px",
      borderRadius: "3px",
      background: i === index ? "#B4D5FF" : "transparent"
    }
  }, char))));
});
QuantumAutoCompletionPortal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "QuantumAutoCompletionPortal"
};

const CHILDREN_TO_CURSOR_STATE_TO_RANGE = new WeakMap();
function getCursorRange(editor, cursorState) {
  if (!cursorState.relativeSelection) {
    return null;
  }
  let cursorStates = CHILDREN_TO_CURSOR_STATE_TO_RANGE.get(editor.children);
  if (!cursorStates) {
    cursorStates = new WeakMap();
    CHILDREN_TO_CURSOR_STATE_TO_RANGE.set(editor.children, cursorStates);
  }
  let range = cursorStates.get(cursorState);
  if (range === undefined) {
    range = relativeRangeToSlateRange(editor.sharedRoot, editor, cursorState.relativeSelection);
    cursorStates.set(cursorState, range);
  }
  return range;
}

const QuantumEditable = _ref => {
  let {
    editor,
    setCursors,
    ...props
  } = _ref;
  const cursorStates = useRemoteCursorStates();
  const overlayData = useMemo(() => Object.entries(cursorStates).map(_ref2 => {
    var _awarenessMeta;
    let [clientId, state] = _ref2;
    const range = state.relativeSelection && getCursorRange(editor, state);
    let data = null;
    let awarenessMeta = [];
    try {
      var _editor$awareness;
      data = Array.from(editor === null || editor === void 0 ? void 0 : (_editor$awareness = editor.awareness) === null || _editor$awareness === void 0 ? void 0 : _editor$awareness.states);
      awarenessMeta = data.find(u => u[0] == clientId);
    } catch (error) {}
    return {
      ...state,
      data: ((_awarenessMeta = awarenessMeta) === null || _awarenessMeta === void 0 ? void 0 : _awarenessMeta.length) > 0 ? awarenessMeta[1] : null,
      range
    };
  }), [cursorStates, editor]);
  useEffect(() => {
    setCursors(overlayData === null || overlayData === void 0 ? void 0 : overlayData.map(u => {
      if (!u.range) return null;
      return {
        anchor: u.range.anchor,
        focus: u.range.focus,
        data: u.data
      };
    }).filter(u => u));
  }, [overlayData]);
  return /*#__PURE__*/React__default.createElement(Editable, props);
};
QuantumEditable.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "QuantumEditable"
};

const AppQuantumBlock = _ref => {
  var _currentTheme$theme;
  let {
    attributes,
    children,
    element,
    style
  } = _ref;
  const editor = useSlateStatic();
  const {
    currentTheme
  } = useTheme();
  const _styles = generateStyle$4();
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ..._styles.customBlockWrapper,
      ...style
    }
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: element !== null && element !== void 0 && element.checked ? AppAssets.icons.check : AppAssets.icons.uncheck,
    isClickable: true,
    onPress: event => {
      const path = ReactEditor.findPath(editor, element);
      const newProperties = {
        checked: !(element !== null && element !== void 0 && element.checked)
      };
      Transforms.setNodes(editor, newProperties, {
        at: path
      });
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingLeft: "10px",
      paddingRight: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("p", _extends({
    style: {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.font_color
    }
  }, attributes), children)), /*#__PURE__*/React__default.createElement("div", {
    contentEditable: false
  }, /*#__PURE__*/React__default.createElement(AppAvatar, {
    label: "Gabriele Sanguigno",
    size: 20
  })));
};
const generateStyle$4 = props => {
  return {
    customBlockWrapper: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      paddingHorizontal: 0
    }
  };
};
AppQuantumBlock.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumBlock"
};

const AppQuantumMentionComponent = _ref => {
  let {
    attributes,
    children,
    element,
    type
  } = _ref;
  const selected = useSelected();
  const focused = useFocused();
  const {
    currentTheme
  } = useTheme();
  const matchingMeta = QuantumConfig.META_TARGETS.filter(u => u.id === type)[0];
  return /*#__PURE__*/React__default.createElement("span", _extends({}, attributes, {
    contentEditable: false,
    style: {
      padding: "3px 3px 2px",
      margin: "0 1px",
      verticalAlign: "baseline",
      display: "inline-block",
      borderRadius: 4,
      backgroundColor: currentTheme.theme[matchingMeta === null || matchingMeta === void 0 ? void 0 : matchingMeta.backgroundColor],
      color: currentTheme.theme[matchingMeta === null || matchingMeta === void 0 ? void 0 : matchingMeta.color],
      boxShadow: selected && focused ? "0 0 0 2px #B4D5FF" : "none"
    }
  }), "".concat(matchingMeta === null || matchingMeta === void 0 ? void 0 : matchingMeta.key).concat(element.character), children);
};
AppQuantumMentionComponent.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumMentionComponent"
};

const withNER = editor => {
  const {
    insertData,
    insertText,
    isInline
  } = editor;
  editor.isInline = element => {
    return element.type === "ner" ? true : isInline(element);
  };

  //   editor.insertText = (text) => {
  //     if (text) {
  //       wrapNER(editor, text);
  //     } else {
  //       insertText(text);
  //     }
  //   };
  editor.attachProperty = (property, value, path) => {
    const bufferData = {
      [property]: value
    };
    Transforms.setNodes(editor, bufferData, {
      at: path
    });
  };
  editor.attachNER = (data, at, force) => {
    var _ner$, _ner$$data, _ner$2, _ner$2$data;
    const [ner] = Editor.nodes(editor, {
      at,
      match: n => !Editor.isEditor(n) && Element$1.isElement(n) && n.type === "ner"
    });
    if ((ner === null || ner === void 0 ? void 0 : ner.length) > 0 && ((_ner$ = ner[0]) === null || _ner$ === void 0 ? void 0 : (_ner$$data = _ner$.data) === null || _ner$$data === void 0 ? void 0 : _ner$$data.coreNER[0]) === (data === null || data === void 0 ? void 0 : data.coreNER[0])) console.log("NER already present", (_ner$2 = ner[0]) === null || _ner$2 === void 0 ? void 0 : (_ner$2$data = _ner$2.data) === null || _ner$2$data === void 0 ? void 0 : _ner$2$data.coreNER[0], data === null || data === void 0 ? void 0 : data.coreNER[0]);else wrapNER(editor, data, at, force);
  };
  return editor;
};
const insertNER = (editor, data, at) => {
  var _selectedText$trim, _selectedText$trim$sp;
  const selectedText = Editor.string(editor, editor.selection);
  editor.selection;
  const _data = {
    coreNER: [data]
  };
  if (editor.selection && (selectedText === null || selectedText === void 0 ? void 0 : selectedText.trim()) !== "" && (selectedText === null || selectedText === void 0 ? void 0 : (_selectedText$trim = selectedText.trim()) === null || _selectedText$trim === void 0 ? void 0 : (_selectedText$trim$sp = _selectedText$trim.split(" ")) === null || _selectedText$trim$sp === void 0 ? void 0 : _selectedText$trim$sp.length) < 4) {
    wrapNER(editor, _data, at);
  } else {
    throw new Error("Please select a valid NER with less than 4 words");
  }
};
const isNERActive = editor => {
  const [ner] = Editor.nodes(editor, {
    match: n => !Editor.isEditor(n) && Element$1.isElement(n) && n.type === "ner"
  });
  return !!ner;
};
const unwrapNER = (editor, at) => {
  let options = {
    match: n => !Editor.isEditor(n) && Element$1.isElement(n) && n.type === "ner"
  };
  if (at) options.at = at;
  Transforms.unwrapNodes(editor, options);
};
const wrapNER = function (editor, data, at) {
  let force = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (isNERActive(editor)) {
    unwrapNER(editor);
  }
  const {
    selection
  } = editor;
  const isCollapsed = selection && Range.isCollapsed(selection);
  const ner = {
    // type: "ner",
    // data,
    // children: isCollapsed ? [{ text: "" }] : [],
    NER: data.coreNER
  };
  if (isCollapsed && !force) {
    Transforms.insertNodes(editor, ner);
  } else {
    if (at) Transforms.select(editor, at);
    const point = Editor.end(editor, editor.selection.anchor.path.slice(0, -1));
    const atLastChar = Point.compare(point, editor.selection.focus);
    Editor.addMark(editor, data.coreNER, true);
    Editor.addMark(editor, "type", "__ner__");
    // Transforms.wrapNodes(editor, ner, options);
    Transforms.collapse(editor, {
      edge: "end"
    });
    if (atLastChar === 0) Transforms.insertFragment(editor, [{
      text: " "
    }]);
  }
};

const AppQuantumNERComponent = _ref => {
  var _element$data2, _element$data3;
  let {
    attributes,
    children,
    element,
    readOnly
  } = _ref;
  const selected = useSelected();
  const focused = useFocused();
  const editor = useSlate();
  const [isMouseHover, setIsMouseHover] = useState(false);
  const [isMouseHoverDelete, setIsMouseHoverDelete] = useState(false);
  const {
    NERStyles
  } = useQuantumEditor();
  const {
    currentTheme,
    mode
  } = useTheme();
  let _styleLabelBackground;
  const nerLabelStyle = useMemo(() => {
    var _element$data;
    return matchEntityLabelWithEntityStyle(element === null || element === void 0 ? void 0 : (_element$data = element.data) === null || _element$data === void 0 ? void 0 : _element$data.coreNER[0], NERStyles);
  }, [element === null || element === void 0 ? void 0 : (_element$data2 = element.data) === null || _element$data2 === void 0 ? void 0 : _element$data2.coreNER[0], JSON.stringify(NERStyles), isMouseHover]);
  _styleLabelBackground = isMouseHover ? "".concat(nerLabelStyle === null || nerLabelStyle === void 0 ? void 0 : nerLabelStyle.backgroundColor, "99") : "".concat(nerLabelStyle === null || nerLabelStyle === void 0 ? void 0 : nerLabelStyle.backgroundColor, "80");
  const _styles = useMemo(() => {
    return styleGenerator$7(currentTheme, isMouseHover, isMouseHoverDelete, 18, _styleLabelBackground, selected, focused);
  }, [currentTheme, isMouseHover, isMouseHoverDelete, 18, _styleLabelBackground, selected, focused]);
  const removeEntity = () => {
    const path = ReactEditor.findPath(editor, element);
    unwrapNER(editor, path);
    Transforms.setNodes(editor, {
      isParsed: false
    }, {
      at: [path[0]]
    });
  };
  const coreNER = element === null || element === void 0 ? void 0 : (_element$data3 = element.data) === null || _element$data3 === void 0 ? void 0 : _element$data3.coreNER;
  const _id = generateRowId();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppTooltip, {
    offsetBottom: -5,
    id: "".concat(_id, "-").concat(coreNER[0]),
    place: "bottom",
    type: mode,
    effect: "solid",
    getContent: () => coreNER[0]
  }), coreNER !== null && coreNER !== void 0 && coreNER.length && children[0].text !== "" ? /*#__PURE__*/React__default.createElement("span", {
    "data-tip": "".concat(_id, "-").concat(coreNER[0]),
    "data-for": "".concat(_id, "-").concat(coreNER[0]),
    "data-slate-node": "text",
    onMouseEnter: () => setIsMouseHover(true),
    onMouseLeave: e => setTimeout(function () {
      !isMouseHoverDelete && setIsMouseHover(false);
    }, 500),
    style: _styles.decLabel,
    attributes: attributes
  }, children) : /*#__PURE__*/React__default.createElement("span", {
    attributes: attributes
  }, children, " "), (editor === null || editor === void 0 ? void 0 : editor.selection) && (coreNER === null || coreNER === void 0 ? void 0 : coreNER.length) && Range.isCollapsed(editor === null || editor === void 0 ? void 0 : editor.selection) && isMouseHover && !readOnly && children[0].text !== "" && /*#__PURE__*/React__default.createElement("span", {
    id: "nerRemove",
    onMouseEnter: () => setIsMouseHoverDelete(true),
    onMouseLeave: () => setIsMouseHoverDelete(false),
    contentEditable: false,
    readOnly: true,
    onClick: () => removeEntity(),
    style: _styles.decDeleteIcon
  }, "\xD7"));
};
const styleGenerator$7 = (props, isMouseHover, isMouseHoverDelete, size, color, selected, focused) => {
  var _props$theme, _props$theme2, _props$theme3;
  return {
    decLabel: {
      color: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.font_color,
      paddingLeft: 3,
      paddingRight: 3,
      backgroundColor: color || "inherit",
      borderRadius: 5,
      boxShadow: selected && focused ? "0 0 0 2px #B4D5FF" : "none",
      borderWidth: 1,
      cursor: "pointer"
    },
    decDeleteIcon: {
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.darkGrey,
      color: props === null || props === void 0 ? void 0 : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.lightGrey,
      textAlign: "center",
      opacity: isMouseHover || isMouseHoverDelete || selected ? 1 : 0,
      position: "absolute",
      marginTop: -1 * size / 2,
      marginLeft: -1 * size / 2,
      width: size,
      height: size,
      borderRadius: size,
      paddingHorizontal: 2,
      verticalAlign: "center",
      MozUserSelect: "-moz-none",
      KhtmlUserSelect: "none",
      WebkitUserSelect: "none",
      userSelect: "none",
      cursor: "pointer"
    }
  };
};
AppQuantumNERComponent.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumNERComponent"
};

const AppQuantumIntentLeaf = _ref => {
  let {
    intents,
    labelProperty = "name"
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator$6(currentTheme);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      // backgroundColor: currentTheme?.theme?.primary,
      borderRadius: "10px",
      //   boxShadow: selected && focused ? "0 0 0 2px #B4D5FF" : "none",
      borderWidth: 1,
      paddingHorizontal: "5px",
      alignItems: "center",
      display: "inline-flex",
      cursor: "pointer"
    },
    contentEditable: false
  }, intents.map((int, i) => /*#__PURE__*/React__default.createElement(AppTextChip, {
    key: i,
    styleContainer: styles.chip,
    label: int[labelProperty],
    styleLabel: {
      fontSize: "10px"
    }
  })));
};
const styleGenerator$6 = props => {
  var _props$theme;
  return StyleSheet.create({
    chip: {
      marginRight: "5px",
      marginLeft: "0px",
      color: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.font_color
    }
  });
};
AppQuantumIntentLeaf.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumIntentLeaf",
  "props": {
    "labelProperty": {
      "defaultValue": {
        "value": "\"name\"",
        "computed": false
      },
      "required": false
    }
  }
};

const AppTrainingRightIcon = _ref => {
  var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3;
  let {
    handleDataUpdateDynamic,
    intentProp,
    IntentStyles,
    element,
    isEnabled,
    isRendered = true
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const editor = useSlateStatic();
  const handleCheck = (v, item) => {
    if (v === true) {
      const array = intentProp ? [...intentProp] : [];
      array.push({
        confidence: 1,
        name: item.label
      });
      handleDataUpdateDynamic(QuantumConfig.INTENT_PROPERTY, [...new Set(array)], false, editor, element);
    } else {
      handleDataUpdateDynamic(QuantumConfig.INTENT_PROPERTY, intentProp === null || intentProp === void 0 ? void 0 : intentProp.filter(i => i.name !== item.label), false, editor, element);
    }
  };
  return /*#__PURE__*/React__default.createElement(AppPopup, {
    topOffset: -30,
    leftOffset: 170,
    icon: AppAssets.icons.intentSelection,
    iconColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.primary,
    popupTitle: "Intent selection",
    modalWrapperStyle: {
      top: 250
    },
    isEnabled: isEnabled,
    iconSize: QuantumConfig.EDITOR_ICON_SIZE,
    isPositionRelativeToTrigger: false,
    modalBarTitleStyle: {
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.small_font_size
    },
    modalStyle: {
      marginVertical: "auto",
      alignSelf: "end",
      marginRight: 40,
      opacity: 0.95,
      minWidth: 200,
      boxShadow: "unset",
      borderWidth: 1,
      borderColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.border_color
    }
  }, isRendered && /*#__PURE__*/React__default.createElement(AppList, {
    keyExtractor: "id",
    items: IntentStyles,
    contentContainerStyle: {
      padding: 10
    },
    renderItem: _ref2 => {
      var _currentTheme$theme4, _intentProp$map;
      let {
        item
      } = _ref2;
      return /*#__PURE__*/React__default.createElement(CheckItem, {
        style: {
          fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.small_font_size
        },
        iconSize: 16,
        wrapperStyle: {
          paddingVertical: 5
        },
        setChecked: v => handleCheck(v, item),
        checked: intentProp === null || intentProp === void 0 ? void 0 : (_intentProp$map = intentProp.map(u => u.name)) === null || _intentProp$map === void 0 ? void 0 : _intentProp$map.includes(item.label)
      }, item.label);
    }
  }));
};
AppTrainingRightIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppTrainingRightIcon",
  "props": {
    "isRendered": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};

const AppQuantumTrainingBlock = _ref => {
  var _currentTheme$theme4;
  let {
    attributes,
    children,
    element,
    style,
    readOnly,
    parseMode
  } = _ref;
  const {
    IntentStyles,
    nlpConfig
  } = useQuantumEditor();
  const editor = useSlateStatic();
  const {
    currentTheme
  } = useTheme();
  const _numberedList = useMemo(() => {
    let listType;
    if (element.type === "list-item") {
      const path = ReactEditor.findPath(editor, element);
      if (editor !== null && editor !== void 0 && editor.children) {
        var _editor$children$path;
        listType = editor === null || editor === void 0 ? void 0 : (_editor$children$path = editor.children[path[0]]) === null || _editor$children$path === void 0 ? void 0 : _editor$children$path.type;
      }
      if (listType === "numbered-list") {
        return path[1] + 1;
      } else if (listType === "bulleted-list") {
        return -1;
      } else return null;
    }
  }, [element.type === "list-item"]);
  useMemo(() => {
    var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3;
    return element.isParsed ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.green : element.lastParsed > 0 ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.orange : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.red;
  }, [element.isParsed, element.lastParsed, currentTheme]);
  const [optionsData, setOptionsData] = useState([]);
  const _styles = generateStyle$3();
  const [rawText, setRawText] = useState(Node.string(element));
  const [isOptionButtonEnabled, setIsOptionButtonEnabled] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const generateOptionsData = useCallback(() => {
    const optionsData = [];
    if (parseMode === false) {
      optionsData.push({
        isNavigation: true,
        icon: AppAssets.icons.trainAI,
        onPress: opt => {},
        uid: QuantumConfig.INTENT_PROPERTY,
        label: "Set intent",
        children: AppMultiSelectionOptions,
        subOptions: IntentStyles === null || IntentStyles === void 0 ? void 0 : IntentStyles.map(u => ({
          id: u.id,
          title: u.label,
          checked: false,
          uid: QuantumConfig.INTENT_PROPERTY,
          onPress: u => {}
        }))
      });
    }
    optionsData.push({
      isNavigation: true,
      icon: AppAssets.icons.settings,
      onPress: opt => {},
      uid: "SETTINGS",
      label: "Set analysis preferences",
      children: AppMultiSwitchOptions,
      subOptions: QuantumConfig.NLP_OPTIONS.map(u => ({
        id: u.id,
        title: u.label,
        ticked: element[u.id] || nlpConfig[u.logicalPropertyName],
        uid: "SETTINGS",
        onPress: u => {}
      }))
    });
    return optionsData;
  }, []);
  const delayedIsParsedAnalysis = useRef(throttle(element => {
    var _Node$string;
    const _text = (_Node$string = Node.string(element)) === null || _Node$string === void 0 ? void 0 : _Node$string.trim();
    setRawText(_text);
    setIsOptionButtonEnabled(_text !== "");
  }, 2000)).current;
  const alignMenuItemsWithElementData = useCallback(_element => {
    var _optionsData$, _optionsData$$subOpti, _optionsData$2, _optionsData$2$subOpt;
    let _optionsData = [...optionsData];
    (_optionsData$ = _optionsData[0]) === null || _optionsData$ === void 0 ? void 0 : (_optionsData$$subOpti = _optionsData$.subOptions) === null || _optionsData$$subOpti === void 0 ? void 0 : _optionsData$$subOpti.map((u, i) => {
      var _element$Constants$IN;
      return u.checked = (_element$Constants$IN = _element[QuantumConfig.INTENT_PROPERTY].map(i => i.name)) === null || _element$Constants$IN === void 0 ? void 0 : _element$Constants$IN.includes(u.title);
    });
    (_optionsData$2 = _optionsData[1]) === null || _optionsData$2 === void 0 ? void 0 : (_optionsData$2$subOpt = _optionsData$2.subOptions) === null || _optionsData$2$subOpt === void 0 ? void 0 : _optionsData$2$subOpt.map(u => {
      return u.ticked = _element[u.id] === true || nlpConfig[u.logicalPropertyName] === 1;
    });
    setOptionsData(_optionsData);
  }, [optionsData]);
  useEffect(() => {
    setOptionsData(optionsData);
  }, [JSON.stringify(optionsData)]);
  useEffect(() => {
    setOptionsData(generateOptionsData());
  }, [parseMode]);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  useEffect(() => {
    if (isMounted && (element === null || element === void 0 ? void 0 : element.isParsed) === true) handleDataUpdate("isParsed", false, false);
  }, [rawText, isMounted]);
  useEffect(() => {
    delayedIsParsedAnalysis(element);
  }, [element]);
  useEffect(() => {
    if (!rawText || rawText === "") {
      parseMode && handleDataUpdate(QuantumConfig.INTENT_PROPERTY, null, false);
      handleDataUpdate("isParsed", false, false);
    }
  }, [rawText]);
  const handleDataUpdate = useCallback((property, value, isArray) => {
    const path = ReactEditor.findPath(editor, element);
    let bufferData = {
      [property]: null
    };
    if (!element[property]) {
      if (isArray) bufferData[property] = [value];else bufferData[property] = value;
    } else {
      if (isArray) bufferData[property] = [...element[property], value];else bufferData[property] = value;
    }
    if (isArray) bufferData[property] = [...new Set(bufferData[property])];
    const newProperties = {
      ...bufferData
    };
    Transforms.setNodes(editor, newProperties, {
      at: path
    });
  }, [editor, element]);
  const handleDataUpdateDynamic = useCallback((property, value, isArray, _editor, _element) => {
    const path = ReactEditor.findPath(_editor, _element);
    let bufferData = {
      [property]: null
    };
    if (!_element[property]) {
      if (isArray) bufferData[property] = [value];else bufferData[property] = value;
    } else {
      if (isArray) bufferData[property] = [..._element[property], value];else bufferData[property] = value;
    }
    if (isArray) bufferData[property] = [...new Set(bufferData[property])];
    const newProperties = {
      ...bufferData
    };
    Transforms.setNodes(_editor, newProperties, {
      at: path
    });
  }, []);
  useCallback(options => {
    if (options) {
      var _options$0$subOptions;
      handleDataUpdate(QuantumConfig.INTENT_PROPERTY, (_options$0$subOptions = options[0].subOptions) === null || _options$0$subOptions === void 0 ? void 0 : _options$0$subOptions.filter(i => i.checked === true).map(u => {
        return {
          confidence: 1,
          name: u.title
        };
      }), false);
      options[1].subOptions.forEach(opt => {
        handleDataUpdate(opt.id, opt.ticked, false);
      });
    }
  }, [handleDataUpdate]);
  const rightIcon = useMemo(() => {
    return /*#__PURE__*/React__default.createElement(AppTrainingRightIcon, {
      handleDataUpdateDynamic: handleDataUpdateDynamic,
      alignMenuItemsWithElementData: alignMenuItemsWithElementData,
      intentProp: element[QuantumConfig.INTENT_PROPERTY],
      IntentStyles: IntentStyles,
      element: element,
      isEnabled: !readOnly && !parseMode
    });
  }, [handleDataUpdateDynamic, alignMenuItemsWithElementData, element[QuantumConfig.INTENT_PROPERTY], IntentStyles, element, readOnly, parseMode]);
  const _cleanedIntents = useMemo(() => {
    var _element$Constants$IN2;
    return (_element$Constants$IN2 = element[QuantumConfig.INTENT_PROPERTY]) === null || _element$Constants$IN2 === void 0 ? void 0 : _element$Constants$IN2.filter(u => u && u.name !== "");
  }, [element]);

  // Added to resolve #340
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ..._styles.customBlockWrapper,
      ...style
    }
  }, _numberedList > 0 && /*#__PURE__*/React__default.createElement("div", {
    contentEditable: false,
    style: {
      width: "25px"
    }
  }, " ", /*#__PURE__*/React__default.createElement("span", {
    contentEditable: false
  }, "".concat(_numberedList, "."))), _numberedList === -1 && /*#__PURE__*/React__default.createElement("div", {
    contentEditable: false,
    style: {
      width: "25px"
    }
  }, " ", /*#__PURE__*/React__default.createElement("span", {
    contentEditable: false
  }, "\u2022")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingLeft: "10px",
      paddingRight: "10px",
      flex: 1
    }
  }, /*#__PURE__*/React__default.createElement("p", _extends({
    style: {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.font_color
    }
  }, attributes), children)), (_cleanedIntents === null || _cleanedIntents === void 0 ? void 0 : _cleanedIntents.length) > 0 && /*#__PURE__*/React__default.createElement(AppQuantumIntentLeaf, {
    intents: _cleanedIntents
  }), rightIcon);
};
const generateStyle$3 = props => {
  return {
    customBlockWrapper: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      paddingHorizontal: 0,
      paddingTop: 10
    }
  };
};
AppQuantumTrainingBlock.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumTrainingBlock"
};

const SingleSelectionComponentWithIcon = _ref => {
  let {
    handleTick,
    listData
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  return /*#__PURE__*/React__default.createElement(AppList, {
    keyExtractor: "id",
    items: listData,
    contentContainerStyle: {
      padding: 10
    },
    renderItem: _ref2 => {
      let {
        item
      } = _ref2;
      return /*#__PURE__*/React__default.createElement(AppText, {
        onPress: () => {
          handleTick(item, "checked");
        },
        isActive: item.checked,
        color: item.checked && currentTheme.theme[item === null || item === void 0 ? void 0 : item.activeColor],
        isClickable: true,
        leftIcon: item.icon
      }, item.title);
    }
  });
};
SingleSelectionComponentWithIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SingleSelectionComponentWithIcon"
};

const priorities = [{
  id: "HIGH",
  label: "High",
  ticked_icon: AppAssets.icons.highPriority,
  unticked_icon: AppAssets.icons.highPriority,
  color: "red"
}, {
  id: "MEDIUM",
  label: "Medium",
  ticked_icon: AppAssets.icons.mediumPriority,
  unticked_icon: AppAssets.icons.mediumPriority,
  color: "orange"
}, {
  id: "LOW",
  label: "Low",
  ticked_icon: AppAssets.icons.lowPriority,
  unticked_icon: AppAssets.icons.lowPriority,
  color: "green"
}];
const tickableEvents = [{
  id: "TASK",
  label: "Task",
  ticked_icon: AppAssets.icons.check,
  unticked_icon: AppAssets.icons.uncheck
}, {
  id: "ISSUE",
  label: "Issue",
  ticked_icon: AppAssets.icons.issue,
  unticked_icon: AppAssets.icons.issue
}, {
  id: "MEETING",
  label: "Meeting",
  ticked_icon: AppAssets.icons.meeting,
  unticked_icon: AppAssets.icons.meeting
}, {
  id: "REQUI",
  label: "Requirement",
  ticked_icon: AppAssets.icons.requirement,
  unticked_icon: AppAssets.icons.requirement
}, {
  id: "DECISION",
  label: "Decision",
  ticked_icon: AppAssets.icons.decision,
  unticked_icon: AppAssets.icons.decision
}, {
  id: "PLAN",
  label: "Plan",
  ticked_icon: AppAssets.icons.plan,
  unticked_icon: AppAssets.icons.plan
}, {
  id: "RISK",
  label: "Risk",
  ticked_icon: AppAssets.icons.risk,
  unticked_icon: AppAssets.icons.risk
}];
const generateUrlForSingleSentenceNLP = _ref => {
  let {
    text,
    baseUrl,
    timezone = "Australia/Sydney",
    region = "en",
    nlpSpit = true,
    implicitSelf = true
  } = _ref;
  let request_url;
  if (text) {
    request_url = "".concat(baseUrl).concat(encodeURIComponent(text !== "" ? text : "@#$%"), "&time_zone=").concat(timezone, "&time_format=").concat(region, "&split=").concat(nlpSpit === true ? 1 : 0, "&Myself=").concat(implicitSelf === true ? 1 : 0);
  } else {
    request_url = "".concat(baseUrl, "[").concat(encodeURIComponent("@#$%"), "]");
  }
  return request_url;
};
const handleDataFromAI = _data => {
  if (_data && _data.length > 0) {
    var _coreNER$intent, _data$;
    const coreNER = _data[0].data;
    return {
      [QuantumConfig.PERSON_PROPERTY]: coreNER.PERSON,
      [QuantumConfig.TIME_PROPERTY]: coreNER.TIME,
      [QuantumConfig.INTENT_PROPERTY]: !((_coreNER$intent = coreNER.intent) !== null && _coreNER$intent !== void 0 && _coreNER$intent.length) ? [coreNER.intent] : coreNER.intent,
      [QuantumConfig.WHAT_PROPERTY]: coreNER.what,
      [QuantumConfig.LANG_PROPERTY]: (_data$ = _data[1]) === null || _data$ === void 0 ? void 0 : _data$.replace("language: ", ""),
      [QuantumConfig.RAW_DATA_PROPERTY]: _data
    };
  }
};
const normaliseAssignees = (assignees, loggedUser, availableUsers) => {
  return assignees === null || assignees === void 0 ? void 0 : assignees.map(u => {
    return {
      ...u,
      user_nickname: QuantumConfig.IMPLICIT_SELF_PRONOUNS.includes(u.text) ? loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.user_nickname : u.text
    };
  });
};
const GetStatusIcon = (status, intent) => {
  let eventIndex = tickableEvents.map(o => o.id).indexOf(intent);
  if (eventIndex > -1) {
    return status === "completed" ? tickableEvents[eventIndex].ticked_icon : tickableEvents[eventIndex].unticked_icon;
  }
};
const GetStatusColor = (status, priority) => {
  var _priorities$filter$;
  return status === "completed" ? "green" : priority ? (_priorities$filter$ = priorities.filter(p => p.id === priority.name)[0]) === null || _priorities$filter$ === void 0 ? void 0 : _priorities$filter$.color : "grey";
};
const isEventActionable = intent => {
  return tickableEvents.map(o => o.id).indexOf(intent) > -1;
};
const getFirstActionableIntent = intentArray => {
  for (let i = 0; i < (intentArray === null || intentArray === void 0 ? void 0 : intentArray.length); i++) {
    const intent = intentArray[i];
    if (isEventActionable(intent.name)) return i;
  }
};
var AppQuantumNLP = {
  generateUrlForSingleSentenceNLP,
  handleDataFromAI,
  normaliseAssignees,
  GetStatusIcon,
  GetStatusColor,
  isEventActionable,
  getFirstActionableIntent
};

const AppQuantumAutoNLPBlockView = _ref => {
  var _element$Constants$PR, _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5, _element$Constants$AS, _currentTheme$theme6, _currentTheme$theme7;
  let {
    style,
    attributes,
    children,
    element,
    optionsData,
    handleMenuOptionsChanges,
    handleDataUpdate
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const [isMouseOver, setMouseOver] = useState(false);
  const _styles = generateStyle$2();
  const status = element[QuantumConfig.STATUS_PROPERTY];
  const intent = element[QuantumConfig.INTENT_PROPERTY];
  const priority = ((_element$Constants$PR = element[QuantumConfig.PRIORITY_OPTION]) === null || _element$Constants$PR === void 0 ? void 0 : _element$Constants$PR.length) > 0 && element[QuantumConfig.PRIORITY_OPTION][0];
  const firstActionableIntent = useMemo(() => {
    var _intent$AppQuantumNLP;
    return intent && ((_intent$AppQuantumNLP = intent[AppQuantumNLP.getFirstActionableIntent(intent)]) === null || _intent$AppQuantumNLP === void 0 ? void 0 : _intent$AppQuantumNLP.name);
  }, [intent]);
  // if (intent)
  //   const firstActionableIntent =
  //     intent[AppQuantumNLP.getFirstActionableIntent(intent)];
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ..._styles.customBlockWrapper,
      ...style
    },
    onMouseEnter: () => setMouseOver(true),
    onMouseLeave: () => setMouseOver(false)
  }, firstActionableIntent && /*#__PURE__*/React__default.createElement(AppIcon, {
    size: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.small_font_size,
    icon: AppQuantumNLP.GetStatusIcon(status, firstActionableIntent),
    color: AppQuantumNLP.GetStatusColor(status, priority),
    isClickable: true,
    onPress: event => {
      handleDataUpdate(QuantumConfig.STATUS_PROPERTY, status !== "completed" ? "completed" : "open", false);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingLeft: "10px",
      paddingRight: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("p", _extends({
    style: {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.font_color
    }
  }, attributes), children)), element[QuantumConfig.DUE_DATE_PROPERTY] !== "TBD" && /*#__PURE__*/React__default.createElement(AppTextChip, {
    backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.green,
    styleContainer: {
      paddingVertical: 0,
      borderColor: "rgba(0,0,0,0)"
    },
    styleLabel: {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.white,
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.extra_small_font_size
    },
    label: element[QuantumConfig.DUE_DATE_PROPERTY]
  }), ((_element$Constants$AS = element[QuantumConfig.ASSIGN_PROPERTY]) === null || _element$Constants$AS === void 0 ? void 0 : _element$Constants$AS.length) > 0 && /*#__PURE__*/React__default.createElement(AppAvatarList, {
    avatarSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.small_font_size,
    namesList: element[QuantumConfig.ASSIGN_PROPERTY],
    labelProperty: "user_nickname"
  }), /*#__PURE__*/React__default.createElement(AppPopup, {
    onPopupShow: () => {},
    icon: AppAssets.icons.option,
    popupTitle: "Options",
    iconStyle: {
      opacity: isMouseOver ? 1 : 0
    }
  }, /*#__PURE__*/React__default.createElement(AppMenuOptions, {
    onChange: options => {
      handleMenuOptionsChanges(options);
    },
    options: optionsData
  })), (element === null || element === void 0 ? void 0 : element.TEXT_ANALYSIS_IN_PROGRESS) && /*#__PURE__*/React__default.createElement(AppSpinner, {
    containerStyle: {
      alignItems: "flex-start"
    },
    size: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.medium_font_size
  }));
};
const generateStyle$2 = props => {
  return {
    customBlockWrapper: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      paddingHorizontal: 0
    }
  };
};
AppQuantumAutoNLPBlockView.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumAutoNLPBlockView"
};

const _optionsData = [{
  isNavigation: true,
  isSingleOption: true,
  icon: AppAssets.icons.trainAI,
  onPress: opt => {},
  uid: QuantumConfig.INTENT_PROPERTY,
  label: "Event type",
  children: AppMultiSelectionOptions,
  subOptions: tickableEvents.map(u => ({
    id: u.id,
    title: u.label,
    checked: false,
    uid: QuantumConfig.INTENT_PROPERTY,
    onPress: u => {}
  }))
}, {
  isNavigation: true,
  isSingleOption: true,
  icon: AppAssets.icons.highPriority,
  onPress: opt => {},
  uid: QuantumConfig.PRIORITY_OPTION,
  label: "Priority",
  children: SingleSelectionComponentWithIcon,
  subOptions: priorities.map(u => ({
    id: u.id,
    title: u.label,
    icon: u.ticked_icon,
    checked: false,
    activeColor: u.color,
    uid: QuantumConfig.PRIORITY_OPTION,
    onPress: u => {}
  }))
}, {
  isNavigation: true,
  icon: AppAssets.icons.settings,
  onPress: opt => {},
  uid: "SETTINGS",
  label: "Set analysis preferences",
  children: AppMultiSwitchOptions,
  subOptions: QuantumConfig.NLP_OPTIONS.map(u => ({
    id: u.id,
    title: u.label,
    ticked: false,
    uid: "SETTINGS",
    onPress: u => {}
  }))
}];
const AppQuantumAutoNLPBlock = _ref => {
  let {
    attributes,
    children,
    element,
    style,
    nlpSecret,
    baseUrl,
    loggedUser,
    readOnly
  } = _ref;
  const {
    isAIEnabled
  } = useQuantumEditor();
  const [optionsData, setOptionsData] = useState(_optionsData);
  const [isMounted, setIsMounted] = useState(false);
  useState(false);
  const editor = useSlateStatic();
  useTheme();
  useState("-9999px");
  useState("-9999px");
  useRef();
  useState(false);
  const person = element[QuantumConfig.PERSON_PROPERTY];
  const dates = element[QuantumConfig.TIME_PROPERTY];
  const rawText = Node.string(element);
  const assignees = useMemo(() => person === null || person === void 0 ? void 0 : person.filter(p => p.is_main_person === "Yes"), [person]);
  const dueDate = useMemo(() => {
    var _dates$;
    return (dates === null || dates === void 0 ? void 0 : dates.length) > 0 && ((_dates$ = dates[0]) === null || _dates$ === void 0 ? void 0 : _dates$.value);
  }, [dates]);
  const delayedNLPAnalysis = useRef(debounce(text => {
    runNLPAnalysis(text);
  }, QuantumConfig.NLP_TIMER)).current;
  const handleDataUpdate = useCallback((property, value, isAdditionToArray) => {
    const path = ReactEditor.findPath(editor, element);
    let bufferData = {
      [property]: null
    };
    if (!element[property]) {
      if (isAdditionToArray) bufferData[property] = [value];else bufferData[property] = value;
    } else {
      if (isAdditionToArray) bufferData[property] = [...element[property], value];else bufferData[property] = value;
    }
    if (isAdditionToArray) bufferData[property] = [...new Set(bufferData[property])];
    const newProperties = {
      ...bufferData
    };
    Transforms.setNodes(editor, newProperties, {
      at: path
    });
  }, [editor, element]);
  const updateElementWithNLPData = useCallback(quantumData => {
    handleDataUpdate(QuantumConfig.INTENT_PROPERTY, quantumData[QuantumConfig.INTENT_PROPERTY], false);
    handleDataUpdate(QuantumConfig.TIME_PROPERTY, quantumData[QuantumConfig.TIME_PROPERTY], false);
    handleDataUpdate(QuantumConfig.PERSON_PROPERTY, quantumData[QuantumConfig.PERSON_PROPERTY], false);
    handleDataUpdate(QuantumConfig.WHAT_PROPERTY, quantumData[QuantumConfig.WHAT_PROPERTY], false);
    handleDataUpdate(QuantumConfig.LANG_PROPERTY, quantumData[QuantumConfig.LANG_PROPERTY], false);
    handleDataUpdate(QuantumConfig.RAW_DATA_PROPERTY, quantumData[QuantumConfig.RAW_DATA_PROPERTY], false);
  }, [handleDataUpdate]);
  const runNLPAnalysis = async text => {
    var _text$trim, _text$trim$split;
    if ((text === null || text === void 0 ? void 0 : (_text$trim = text.trim()) === null || _text$trim === void 0 ? void 0 : (_text$trim$split = _text$trim.split(" ")) === null || _text$trim$split === void 0 ? void 0 : _text$trim$split.length) >= QuantumConfig.MIN_WORDS_FOR_NLP) {
      handleDataUpdate("TEXT_ANALYSIS_IN_PROGRESS", true, false);
      const response = await fetch(AppQuantumNLP.generateUrlForSingleSentenceNLP({
        text,
        baseUrl
      }), {
        method: "GET",
        // *GET, POST, PUT, DELETE, etc.
        headers: {
          "x-api-key": nlpSecret
        }
      });
      const _data = await response.json();
      handleDataUpdate("TEXT_ANALYSIS_IN_PROGRESS", false, false);
      const quantumData = AppQuantumNLP.handleDataFromAI(_data);
      updateElementWithNLPData(quantumData);
    }
  };
  const handleMenuOptionsChanges = options => {
    var _options$0$subOptions, _options$1$subOptions;
    handleDataUpdate(QuantumConfig.INTENT_PROPERTY, (_options$0$subOptions = options[0].subOptions) === null || _options$0$subOptions === void 0 ? void 0 : _options$0$subOptions.filter(i => i.checked === true).map(u => {
      return {
        confidence: 1,
        name: u.id
      };
    }), false);
    handleDataUpdate(QuantumConfig.PRIORITY_OPTION, (_options$1$subOptions = options[1].subOptions) === null || _options$1$subOptions === void 0 ? void 0 : _options$1$subOptions.filter(i => i.checked === true).map(u => {
      return {
        confidence: 1,
        name: u.id
      };
    }), false);
    options[2].subOptions.forEach(opt => {
      handleDataUpdate(opt.id, opt.ticked, false);
    });
  };
  useEffect(() => {
    setIsMounted(true);
  }, []);
  useEffect(() => {
    isMounted && isAIEnabled && delayedNLPAnalysis(rawText);
  }, [rawText]);
  useEffect(() => {
    const refinedAssignes = AppQuantumNLP.normaliseAssignees(assignees, loggedUser);
    handleDataUpdate(QuantumConfig.ASSIGN_PROPERTY, refinedAssignes, false);
  }, [assignees, loggedUser]);
  useEffect(() => {
    const refinedDueDate = dateConverter.generateDateDisplayed(dueDate);
    handleDataUpdate(QuantumConfig.DUE_DATE_PROPERTY, refinedDueDate, false);
  }, [dueDate]);
  return /*#__PURE__*/React__default.createElement(AppQuantumAutoNLPBlockView, {
    readOnly: readOnly,
    element: element,
    attributes: attributes,
    children: children,
    handleMenuOptionsChanges: handleMenuOptionsChanges,
    handleDataUpdate: handleDataUpdate,
    optionsData: optionsData,
    style: style
  });
};
AppQuantumAutoNLPBlock.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumAutoNLPBlock"
};

const ImageElement = _ref => {
  var _currentTheme$theme;
  let {
    attributes,
    children,
    element,
    S3downloadUrlRequest,
    workspaceid,
    fileUploadInProgress,
    imageFileNameUploadProgress,
    fileUploadProgress
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const selected = useSelected();
  const focused = useFocused();
  const [url, setUrl] = React__default.useState("");
  const getUrl = async () => {
    const _url = await S3downloadUrlRequest({
      filename: "imported-image/".concat(workspaceid, "/").concat(element === null || element === void 0 ? void 0 : element.url),
      context: "pdf",
      workspaceid
    });
    setUrl(_url === null || _url === void 0 ? void 0 : _url.url);
  };
  useEffect(() => {
    getUrl();
  }, [element === null || element === void 0 ? void 0 : element.url]);
  useEffect(() => {
    if ((element === null || element === void 0 ? void 0 : element.type) === "image" && element !== null && element !== void 0 && element.url && element !== null && element !== void 0 && element.isPrivate) {
      getUrl();
    }
  }, [element === null || element === void 0 ? void 0 : element.type, element === null || element === void 0 ? void 0 : element.url, element === null || element === void 0 ? void 0 : element.isPrivate]);
  return /*#__PURE__*/React__default.createElement("div", attributes, children, element !== null && element !== void 0 && element.isLoading ? /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(AppActivityIndicator, {
    visible: true,
    size: 24,
    containerStyle: {
      flex: 0,
      flexBasis: 36
    }
  }), /*#__PURE__*/React__default.createElement(AppText, {
    wrapperStyle: {
      marginTop: 5
    },
    color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.primary
  }, "Uploading image - ".concat(fileUploadProgress || 0, "%"))) : /*#__PURE__*/React__default.createElement("img", {
    alt: "img_edit",
    src: element !== null && element !== void 0 && element.isPrivate ? url : element.url,
    style: {
      display: "block",
      maxWidth: "100%",
      maxHeight: "20em",
      boxShadow: "".concat(selected && focused ? "0 0 0 2px grey" : "none")
    }
  }));
};
ImageElement.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ImageElement"
};

const withLinks = editor => {
  const {
    insertData,
    insertText,
    isInline,
    normalizeNode
  } = editor;
  editor.normalizeNode = _ref => {
    var _node$children, _node$children$find;
    let [node, path] = _ref;
    // If the node is a link and it's empty (i.e., its text is empty), unwrap it
    if (node.type === "link" && Node.string(node).length === 0 || (node === null || node === void 0 ? void 0 : (_node$children = node.children) === null || _node$children === void 0 ? void 0 : (_node$children$find = _node$children.find(child => child.type === "link")) === null || _node$children$find === void 0 ? void 0 : _node$children$find.text) === "") {
      unwrapLink(editor);
      Editor.removeMark(editor, "url");
      Editor.removeMark(editor, "type");
    }
    return normalizeNode([node, path]);
  };
  editor.isInline = element => {
    return element.type === "link" ? true : isInline(element);
  };
  editor.insertText = text => {
    if (text && isUrl(text)) {
      wrapLink(editor, text);
    } else {
      insertText(text);
    }
  };
  editor.insertData = data => {
    const text = data.getData("text/plain");
    if (text && isUrl(text)) {
      wrapLink(editor, text);
    } else {
      insertData(data);
    }
  };
  return editor;
};
const isLinkActive = editor => {
  const [link] = Editor.nodes(editor, {
    match: n => !Editor.isEditor(n) && Element$1.isElement(n) && n.type === "link"
  });
  return !!link;
};
const unwrapLink = editor => {
  Transforms.unwrapNodes(editor, {
    match: n => !Editor.isEditor(n) && Element$1.isElement(n) && n.type === "link"
  });
};
const wrapLink = (editor, url) => {
  if (isLinkActive(editor)) {
    unwrapLink(editor);
  }
  const {
    selection
  } = editor;
  const isCollapsed = selection && Range.isCollapsed(selection);
  const link = {
    type: "link",
    url,
    children: isCollapsed ? [{
      text: url
    }] : []
  };
  if (isCollapsed) {
    Transforms.insertNodes(editor, link);
  } else {
    Transforms.wrapNodes(editor, link, {
      split: true
    });
    Transforms.collapse(editor, {
      edge: "end"
    });
  }
};

const AppQuantumLink = _ref => {
  var _currentTheme$theme;
  let {
    attributes,
    element,
    children,
    href
  } = _ref;
  const editor = useSlateStatic();
  const selected = useSelected();
  const focused = useFocused();
  const {
    currentTheme
  } = useTheme();
  const [isMouseHover, setIsMouseHover] = useState(false);
  const [isMouseHoverDelete, setIsMouseHoverDelete] = useState(false);
  const _styles = styleGenerator$5(currentTheme, isMouseHover, isMouseHoverDelete, 18, selected);
  return /*#__PURE__*/React__default.createElement("p", {
    style: {
      position: "relative",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement("a", _extends({
    style: {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.primary,
      cursor: "pointer"
    },
    onClick: () => window.open(href, "_blank")
  }, attributes, {
    href: href,
    title: href === null || href === void 0 ? void 0 : href.toString()
  }), children), selected && focused && /*#__PURE__*/React__default.createElement("span", {
    id: "nerRemove"
    //    onMouseEnter={() => setIsMouseHoverDelete(true)}
    //    onMouseLeave={() => setIsMouseHoverDelete(false)}
    ,
    contentEditable: false,
    readOnly: true,
    onClick: () => unwrapLink(editor),
    style: _styles.decDeleteIcon
  }, "\xD7"));
};
const styleGenerator$5 = (props, isMouseHover, isMouseHoverDelete, size, selected, focused) => {
  var _props$theme, _props$theme2;
  return {
    decDeleteIcon: {
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.primary,
      color: props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.white,
      textAlign: "center",
      opacity: isMouseHover || isMouseHoverDelete || selected ? 1 : 0,
      position: "absolute",
      marginTop: -1 * size / 2,
      marginLeft: -1 * size / 2,
      width: size,
      height: size,
      borderRadius: size,
      paddingHorizontal: 2,
      verticalAlign: "center",
      MozUserSelect: "-moz-none",
      KhtmlUserSelect: "none",
      WebkitUserSelect: "none",
      userSelect: "none",
      cursor: "pointer"
    }
    // DEPRECATED VERSION OF APP ICON STYLE
    // decDeleteIcon: {
    //   backgroundColor: props?.theme?.black,
    //   color: props?.theme?.font_color,
    //   height: props?.theme?.base_font_size,
    //   opacity: isMouseHover ? 1 : 0,
    //   position: "absolute",
    //   right: -10,
    //   top: -20,
    //   width: props?.theme?.base_font_size,
    // },
  };
};
AppQuantumLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumLink"
};

const AppQuantumAQuestionBlock = _ref => {
  var _element$Constants$AN, _currentTheme$theme8, _currentTheme$theme9, _element$Constants$AN3, _element$Constants$AN4, _element$Constants$AN5, _currentTheme$theme10, _currentTheme$theme11, _element$Constants$AN6, _element$Constants$AN7, _currentTheme$theme12, _currentTheme$theme13;
  let {
    attributes,
    children,
    element,
    style,
    readOnly,
    baseDocumentRedirectLink
  } = _ref;
  const rawText = Node.string(element);
  const [isMounted, setIsMounted] = useState(false);
  useState(false);
  const editor = useSlateStatic();
  const {
    currentTheme
  } = useTheme();
  const _styles = generateStyle$1();
  useState([]);
  const _iconColor = useMemo(() => {
    var _currentTheme$theme2, _currentTheme$theme3;
    if (element.isAnswer) {
      var _currentTheme$theme;
      return currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.green;
    } else if (element.isParsed) return currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.green;else return currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.primary;
  }, [currentTheme, element.isAnswer, element.isParsed]);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  useEffect(() => {
    isMounted && handleDataUpdate("isParsed", false, false);
    isMounted && (rawText === null || rawText === void 0 ? void 0 : rawText.trim()) === "" && handleDataUpdate("isAnswer", false, false);
  }, [rawText, isMounted]);
  const handleDataUpdate = useCallback((property, value, isArray) => {
    const path = ReactEditor.findPath(editor, element);
    let bufferData = {
      [property]: null
    };
    if (!element[property]) {
      if (isArray) bufferData[property] = [value];else bufferData[property] = value;
    } else {
      if (isArray) bufferData[property] = [...element[property], value];else bufferData[property] = value;
    }
    if (isArray) bufferData[property] = [...new Set(bufferData[property])];
    const newProperties = {
      ...bufferData
    };
    Transforms.setNodes(editor, newProperties, {
      at: path
    });
  }, [editor, element]);
  // Added to resolve #340
  useEffect(() => {
    if (!rawText || rawText === "") {
      handleDataUpdate(QuantumConfig.ANSWERS_PROPERTY, null, false);
      handleDataUpdate(QuantumConfig.ANSWER_PROPERTY, null, false);
      handleDataUpdate("isParsed", false, false);
    }
  }, [rawText]);
  // Added to resolve #340
  const nestedP = ((_element$Constants$AN = element[QuantumConfig.ANSWERS_PROPERTY]) === null || _element$Constants$AN === void 0 ? void 0 : _element$Constants$AN.map((u, i) => {
    var _currentTheme$theme4, _currentTheme$theme5, _currentTheme$theme6, _currentTheme$theme7, _element$Constants$AN2;
    return /*#__PURE__*/React__default.createElement("span", {
      style: {
        fontFamily: "boldFont",
        fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.small_font_size,
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.primary
      }
    }, u.translatedAnswer || u.answer, " (", /*#__PURE__*/React__default.createElement("a", {
      style: {
        fontFamily: "boldFont",
        fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.small_font_size,
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.blue
      },
      href: "".concat(baseDocumentRedirectLink, "/").concat(u.documentId),
      target: "_blank",
      rel: "noopener noreferrer"
    }, "".concat(u.documentId)), ") ", ((_element$Constants$AN2 = element[QuantumConfig.ANSWERS_PROPERTY]) === null || _element$Constants$AN2 === void 0 ? void 0 : _element$Constants$AN2.length) - 1 !== i && "or ");
  })) || " ";
  const inLineP = element[QuantumConfig.ANSWER_PROPERTY] ? /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontFamily: "boldFont",
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.small_font_size,
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme9 = currentTheme.theme) === null || _currentTheme$theme9 === void 0 ? void 0 : _currentTheme$theme9.primary
    }
  }, ((_element$Constants$AN3 = element[QuantumConfig.ANSWER_PROPERTY]) === null || _element$Constants$AN3 === void 0 ? void 0 : _element$Constants$AN3.translatedAnswer) || ((_element$Constants$AN4 = element[QuantumConfig.ANSWER_PROPERTY]) === null || _element$Constants$AN4 === void 0 ? void 0 : _element$Constants$AN4.answer), " ", "(", ((_element$Constants$AN5 = element[QuantumConfig.ANSWER_PROPERTY]) === null || _element$Constants$AN5 === void 0 ? void 0 : _element$Constants$AN5.documentId) && /*#__PURE__*/React__default.createElement("a", {
    style: {
      fontFamily: "boldFont",
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme10 = currentTheme.theme) === null || _currentTheme$theme10 === void 0 ? void 0 : _currentTheme$theme10.small_font_size,
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme11 = currentTheme.theme) === null || _currentTheme$theme11 === void 0 ? void 0 : _currentTheme$theme11.blue
    },
    href: "".concat(baseDocumentRedirectLink, "/").concat((_element$Constants$AN6 = element[QuantumConfig.ANSWER_PROPERTY]) === null || _element$Constants$AN6 === void 0 ? void 0 : _element$Constants$AN6.documentId),
    target: "_blank",
    rel: "noopener noreferrer"
  }, "".concat((_element$Constants$AN7 = element[QuantumConfig.ANSWER_PROPERTY]) === null || _element$Constants$AN7 === void 0 ? void 0 : _element$Constants$AN7.documentId)), ")") : " ";
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ..._styles.customBlockWrapper,
      ...style
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingLeft: "10px",
      paddingRight: "10px",
      flex: 1
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row"
    }
  }, !readOnly && /*#__PURE__*/React__default.createElement(AppIcon, {
    size: QuantumConfig.EDITOR_ICON_SIZE,
    style: {
      marginRight: element !== null && element !== void 0 && element.isAnswer ? 30 : 10
    },
    icon: element !== null && element !== void 0 && element.isAnswer ? AppAssets.icons.answer_icon : AppAssets.icons.question_icon,
    color: _iconColor
  }), /*#__PURE__*/React__default.createElement("p", _extends({
    style: {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme12 = currentTheme.theme) === null || _currentTheme$theme12 === void 0 ? void 0 : _currentTheme$theme12.font_color,
      flex: 1
    }
  }, attributes), children)), (element[QuantumConfig.ANSWERS_PROPERTY] || element[QuantumConfig.ANSWER_PROPERTY]) && /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginBlockStart: 0,
      marginBlockEnd: 0,
      marginTop: -10,
      marginLeft: 40,
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme13 = currentTheme.theme) === null || _currentTheme$theme13 === void 0 ? void 0 : _currentTheme$theme13.font_color
    },
    contentEditable: false
  }, element[QuantumConfig.ANSWERS_PROPERTY] ? nestedP : inLineP)));
};
// </>

const generateStyle$1 = props => {
  return {
    customBlockWrapper: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      paddingHorizontal: 0
    }
  };
};
AppQuantumAQuestionBlock.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumAQuestionBlock"
};

const EditableVoid = _ref => {
  var _element$Constants$CO, _element$Constants$CO2, _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5, _currentTheme$theme6, _currentTheme$theme7, _currentTheme$theme8, _currentTheme$theme9;
  let {
    attributes,
    children,
    element
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const [questionValue, setQuestionValue] = useState(element[QuantumConfig.QUESTION_TRAINED_PROPERTY]);
  const [answerValue, setAnswerValue] = useState(element[QuantumConfig.ANSWER_TRAINED_PROPERTY]);
  const [contextValue, setContextValue] = useState(element[QuantumConfig.CONTEXT_PROPERTY]);
  const [isContextForced, setIsContextForced] = useState(((_element$Constants$CO = element[QuantumConfig.CONTEXT_PROPERTY]) === null || _element$Constants$CO === void 0 ? void 0 : _element$Constants$CO.length) > 0);
  const [isContextPassageDisabled, setIsPassageInContextDisabled] = useState(((_element$Constants$CO2 = element[QuantumConfig.CONTEXT_PROPERTY]) === null || _element$Constants$CO2 === void 0 ? void 0 : _element$Constants$CO2.length) > 0);
  const {
    setIndexesInContext
  } = useQuantumEditor();
  const editor = useSlateStatic();
  const path = ReactEditor.findPath(editor, element);
  const deleteQ = useCallback(event => {
    Transforms.delete(editor, {
      at: ReactEditor.findPath(editor, element)
    });
  }, [editor]);
  const showContext = useCallback(() => {
    const {
      blockIndexesUsedForContext
    } = getTextAroundIndex(path[0], editor);
    setIndexesInContext(blockIndexesUsedForContext);
    setTimeout(() => {
      setIndexesInContext([]);
    }, QuantumConfig.CONTEXT_TIMER);
  }, [path, editor]);
  const handleDataUpdate = useCallback((property, value, isArray) => {
    const path = ReactEditor.findPath(editor, element);
    let bufferData = {
      [property]: null
    };
    if (!element[property]) {
      if (isArray) bufferData[property] = [value];else bufferData[property] = value;
    } else {
      if (isArray) bufferData[property] = [...element[property], value];else bufferData[property] = value;
    }
    if (isArray) bufferData[property] = [...new Set(bufferData[property])];
    const newProperties = {
      ...bufferData
    };
    Transforms.setNodes(editor, newProperties, {
      at: path
    });
  }, [editor, element]);
  useEffect(() => {
    if (element[QuantumConfig.QUESTION_TRAINED_PROPERTY] !== null && element[QuantumConfig.QUESTION_TRAINED_PROPERTY] !== questionValue) {
      setQuestionValue(element[QuantumConfig.QUESTION_TRAINED_PROPERTY]);
    }
    if (element[QuantumConfig.ANSWER_TRAINED_PROPERTY] !== null && element[QuantumConfig.ANSWER_TRAINED_PROPERTY] !== answerValue) {
      setAnswerValue(element[QuantumConfig.ANSWER_TRAINED_PROPERTY]);
    }
    if (element[QuantumConfig.CONTEXT_PROPERTY] !== null && element[QuantumConfig.CONTEXT_PROPERTY] !== contextValue) {
      setContextValue(element[QuantumConfig.CONTEXT_PROPERTY]);
    }
  }, [element[QuantumConfig.QUESTION_TRAINED_PROPERTY], element[QuantumConfig.ANSWER_TRAINED_PROPERTY], element[QuantumConfig.CONTEXT_PROPERTY]]);
  return (
    /*#__PURE__*/
    // Need contentEditable=false or Firefox has issues with certain input types.
    React__default.createElement("div", _extends({}, attributes, {
      contentEditable: false
    }), /*#__PURE__*/React__default.createElement("div", {
      style: {
        boxShadow: "0 0 0 1px ".concat(currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.lightGrey),
        padding: "10px",
        borderRadius: "10px",
        marginLeft: "0px",
        marginTop: "10px",
        backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.backgroundContrastColor
      }
    }, /*#__PURE__*/React__default.createElement(View, {
      style: {
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap",
        alignItems: "center",
        paddingBottom: 2
      }
    }, /*#__PURE__*/React__default.createElement(View, {
      style: {
        flexDirection: "row",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement(AppText, {
      style: {
        fontWeight: "bold"
      }
    }, "Question"), /*#__PURE__*/React__default.createElement(AppText, {
      color: isContextForced ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.darkGrey : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.blue
      // tooltip={"Show context"}
      ,
      wrapperStyle: {
        marginHorizontal: 10
      },
      isClickable: !isContextForced,
      onPress: showContext,
      rightIcon: AppAssets.icons.info,
      iconSize: 16,
      leftIconColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.darkGrey
    }, "( Show context )"), /*#__PURE__*/React__default.createElement(AppSwitch, {
      labelStyle: {
        paddingRight: 25
      },
      labelTextStyle: {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.darkGrey
      },
      wrapperStyle: {
        paddingRight: 25,
        paddingVertical: 5
      },
      displayIsTicked: true,
      activeText: "True",
      inActiveText: "False",
      showTextInputLabel: true,
      label: "Force context",
      isTicked: isContextForced,
      onChange: b => {
        if (b === false) {
          setContextValue("");
          handleDataUpdate(QuantumConfig.CONTEXT_PROPERTY, "", false);
        } else {
          handleDataUpdate(QuantumConfig.ANSWER_IN_CONTEXT_PROPERTY, b, false);
        }
        setIsContextForced(b);
        setTimeout(() => {
          setIsPassageInContextDisabled(b);
        }, [1000]);
      }
    })), /*#__PURE__*/React__default.createElement(View, {
      style: {
        flexDirection: "row",
        justifyContent: "space-around",
        display: "flex",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement(AppSwitch, {
      labelStyle: {
        paddingRight: 25
      },
      labelTextStyle: {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.darkGrey
      },
      disabled: isContextPassageDisabled,
      wrapperStyle: {
        paddingRight: 25,
        paddingVertical: 5
      },
      displayIsTicked: true,
      activeText: "True",
      inActiveText: "False",
      showTextInputLabel: true,
      label: "Answer in context",
      isTicked: element[QuantumConfig.ANSWER_IN_CONTEXT_PROPERTY] !== false,
      onChange: b => {
        handleDataUpdate(QuantumConfig.ANSWER_IN_CONTEXT_PROPERTY, b, false);
      }
    }), /*#__PURE__*/React__default.createElement(AppIcon
    // tooltip={"Delete snippet"}
    , {
      isClickable: true,
      onPress: deleteQ,
      icon: AppAssets.icons.delete,
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.red
    }))), isContextForced && /*#__PURE__*/React__default.createElement(AppTextInput, {
      placeholder: "Context override",
      style: {
        marginTop: 2
      },
      textContainer: {
        minHeight: 120,
        paddingTop: 3,
        borderRadius: 10
      },
      type: "text",
      multiline: true,
      value: contextValue,
      onChangeText: text => {
        setContextValue(text);
        handleDataUpdate(QuantumConfig.CONTEXT_PROPERTY, text, false);
      }
    }), /*#__PURE__*/React__default.createElement(AppTextInput, {
      placeholder: "Enter question to train your model",
      style: {
        marginTop: 2
      },
      textContainer: {
        borderRadius: 10,
        marginLeft: 0
      },
      type: "text",
      value: questionValue,
      onChangeText: text => {
        setQuestionValue(text);
        handleDataUpdate(QuantumConfig.QUESTION_TRAINED_PROPERTY, text, false);
      }
    }), /*#__PURE__*/React__default.createElement(AppText, {
      style: {
        fontWeight: "bold"
      }
    }, "Answer"), /*#__PURE__*/React__default.createElement(AppTextInput, {
      placeholder: "Enter the expected answer",
      style: {
        marginTop: 2
      },
      textContainer: {
        minHeight: 120,
        paddingTop: 3,
        borderRadius: 10
      },
      type: "text",
      multiline: true,
      value: answerValue,
      onChangeText: text => {
        setAnswerValue(text);
        handleDataUpdate(QuantumConfig.ANSWER_TRAINED_PROPERTY, text, false);
      }
    }), element["IS_VALID"] === false && /*#__PURE__*/React__default.createElement(AppText, {
      style: {
        fontWeight: "bold"
      },
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme9 = currentTheme.theme) === null || _currentTheme$theme9 === void 0 ? void 0 : _currentTheme$theme9.red
    }, "Invalid snippet: the answer is longer than the context length. Please shorten the answer or increase the context length.")), children)
  );
};
EditableVoid.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EditableVoid"
};

const EditableVoidGn = _ref => {
  var _element$Constants$PR, _element$Constants$PR2, _ref2, _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5, _currentTheme$theme6, _currentTheme$theme7, _currentTheme$theme8, _currentTheme$theme9, _currentTheme$theme10, _currentTheme$theme11;
  let {
    attributes,
    children,
    element
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const [completionValue, setCompletionValue] = useState(element[QuantumConfig.COMPLETION_TRAINED_PROPERTY]);
  const [nonPreferredCompletionValue, setNonPreferredCompletionValue] = useState(element[QuantumConfig.NON_PREFERRED_COMPLETION_TRAINED_PROPERTY]);
  const [contextValue, setContextValue] = useState(element[QuantumConfig.PROMPT_PROPERTY]);
  const [systemPromptValue, setSystemPromptValue] = useState(element[QuantumConfig.SYS_PROMPT_PROPERTY]);
  const [isContextForced, setIsContextForced] = useState(((_element$Constants$PR = element[QuantumConfig.PROMPT_PROPERTY]) === null || _element$Constants$PR === void 0 ? void 0 : _element$Constants$PR.length) > 0);
  const [isContextPassageDisabled, setIsPassageInContextDisabled] = useState(((_element$Constants$PR2 = element[QuantumConfig.PROMPT_PROPERTY]) === null || _element$Constants$PR2 === void 0 ? void 0 : _element$Constants$PR2.length) > 0);
  const isConversational = element === null || element === void 0 ? void 0 : element.is_conversational;
  const isDPO = element === null || element === void 0 ? void 0 : element.IS_DPO;
  const isSystem = element === null || element === void 0 ? void 0 : element.IS_SYSTEM;
  const [roleValue, setRoleValue] = useState(isDPO ? "assistant" : element[QuantumConfig.ROLE_PROPERTY] ? element[QuantumConfig.ROLE_PROPERTY] : "user");
  const options = (_ref2 = [{
    id: "system",
    name: "System"
  }, {
    id: "user",
    name: "User"
  }, {
    id: "assistant",
    name: "Assistant"
  }]) === null || _ref2 === void 0 ? void 0 : _ref2.filter(u => u.id == "system" && isSystem || u.id != "system");
  const {
    setIndexesInContext
  } = useQuantumEditor();
  const editor = useSlateStatic();
  const path = ReactEditor.findPath(editor, element);
  const deleteQ = useCallback(event => {
    Transforms.delete(editor, {
      at: ReactEditor.findPath(editor, element)
    });
  }, [editor]);
  const showContext = useCallback(() => {
    const {
      blockIndexesUsedForContext
    } = getTextAroundIndex(path[0], editor, true);
    setIndexesInContext(blockIndexesUsedForContext);
    setTimeout(() => {
      setIndexesInContext([]);
    }, QuantumConfig.CONTEXT_TIMER);
  }, [path, editor, QuantumConfig.CONTEXT_TIMER, setIndexesInContext]);
  const handleDataUpdate = useCallback((property, value, isArray) => {
    const path = ReactEditor.findPath(editor, element);
    let bufferData = {
      [property]: null
    };
    if (!element[property]) {
      if (isArray) bufferData[property] = [value];else bufferData[property] = value;
    } else {
      if (isArray) bufferData[property] = [...element[property], value];else bufferData[property] = value;
    }
    if (isArray) bufferData[property] = [...new Set(bufferData[property])];
    const newProperties = {
      ...bufferData
    };
    Transforms.setNodes(editor, newProperties, {
      at: path
    });
  }, [editor, element]);
  useEffect(() => {
    if (element[QuantumConfig.COMPLETION_TRAINED_PROPERTY] !== null && element[QuantumConfig.COMPLETION_TRAINED_PROPERTY] !== completionValue) {
      setCompletionValue(element[QuantumConfig.COMPLETION_TRAINED_PROPERTY]);
    }
    if (element[QuantumConfig.NON_PREFERRED_COMPLETION_TRAINED_PROPERTY] !== null && element[QuantumConfig.NON_PREFERRED_COMPLETION_TRAINED_PROPERTY] !== nonPreferredCompletionValue) {
      setNonPreferredCompletionValue(element[QuantumConfig.NON_PREFERRED_COMPLETION_TRAINED_PROPERTY]);
    }
    if (element[QuantumConfig.PROMPT_PROPERTY] !== null && element[QuantumConfig.PROMPT_PROPERTY] !== contextValue) {
      setContextValue(element[QuantumConfig.PROMPT_PROPERTY]);
    }
    if (element[QuantumConfig.SYS_PROMPT_PROPERTY] !== null && element[QuantumConfig.SYS_PROMPT_PROPERTY] !== systemPromptValue) {
      setSystemPromptValue(element[QuantumConfig.SYS_PROMPT_PROPERTY]);
    }
    if (element[QuantumConfig.IS_CONTEXT_FORCED] !== null && element[QuantumConfig.IS_CONTEXT_FORCED] !== isContextForced) {
      setIsContextForced(element[QuantumConfig.IS_CONTEXT_FORCED]);
    }
    if (element[QuantumConfig.ROLE_PROPERTY] !== null && element[QuantumConfig.ROLE_PROPERTY] !== roleValue) {
      setRoleValue(element[QuantumConfig.ROLE_PROPERTY]);
    }
  }, [element[QuantumConfig.COMPLETION_TRAINED_PROPERTY], element[QuantumConfig.PROMPT_PROPERTY], element[QuantumConfig.SYS_PROMPT_PROPERTY], element[QuantumConfig.IS_CONTEXT_FORCED], element[QuantumConfig.ROLE_PROPERTY]]);
  return (
    /*#__PURE__*/
    // Need contentEditable=false or Firefox has issues with certain input types.
    React__default.createElement("div", _extends({}, attributes, {
      contentEditable: false
    }), /*#__PURE__*/React__default.createElement("div", {
      style: {
        // boxShadow: `0 0 0 1px ${currentTheme?.theme?.lightGrey}`,
        padding: "10px",
        borderRadius: "10px",
        // border: `1px solid ${currentTheme?.theme?.border_color}`,
        marginLeft: "0px",
        marginTop: "10px",
        backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.lightGrey,
        border: "1px solid ".concat(element[QuantumConfig.ROLE_PROPERTY] == "assistant" ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.purple : element[QuantumConfig.ROLE_PROPERTY] == "system" ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.orange : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.primary)
      }
    }, /*#__PURE__*/React__default.createElement(View, {
      style: {
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap",
        alignItems: "center",
        paddingBottom: 2
      }
    }, /*#__PURE__*/React__default.createElement(View, {
      style: {
        flexDirection: "row",
        alignItems: "center"
      }
    }, isConversational ? /*#__PURE__*/React__default.createElement(View, {
      style: {
        flexDirection: "row",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement(AppDropDown, {
      showTextInputLabel: false,
      label: "Role",
      inputLabelStyle: {
        marginLeft: 0
      },
      dropDownStyle: {
        minWidth: 100,
        borderColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.border_color,
        maxWidth: 250,
        height: 30,
        fontSize: 14
      },
      disabled: isSystem || isDPO,
      isElevated: false,
      dropdownIconColor: "transparent",
      items: options,
      propertyLabel: "name",
      propertyValue: "id",
      selectedValue: roleValue,
      onValueChange: (itemValue, itemIndex) => {
        setRoleValue(itemValue);
        handleDataUpdate(QuantumConfig.ROLE_PROPERTY, itemValue, false);
      }
    })) : /*#__PURE__*/React__default.createElement(AppText, {
      style: {
        fontWeight: "bold"
      }
    }, "Completion"), !isConversational && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppText, {
      color: isContextForced ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.darkGrey : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.primary
      // tooltip={"Show context"}
      ,
      wrapperStyle: {
        marginHorizontal: 10
      },
      isClickable: !isContextForced,
      onPress: showContext,
      rightIcon: AppAssets.icons.info,
      iconSize: 16,
      leftIconColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.darkGrey
    }, "Context"), /*#__PURE__*/React__default.createElement(AppSwitch, {
      labelStyle: {
        paddingRight: 6
      },
      labelTextStyle: {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme9 = currentTheme.theme) === null || _currentTheme$theme9 === void 0 ? void 0 : _currentTheme$theme9.darkGrey
      },
      wrapperStyle: {
        paddingRight: 6,
        paddingVertical: 5
      },
      displayIsTicked: false,
      activeText: "True",
      inActiveText: "False",
      showTextInputLabel: true,
      label: "Force",
      isTicked: isContextForced,
      onChange: b => {
        if (b === false) {
          setContextValue("");
          handleDataUpdate(QuantumConfig.PROMPT_PROPERTY, "", false);
        } else {
          handleDataUpdate(QuantumConfig.PROMPT_PROPERTY, "", false);
        }
        setIsContextForced(b);
        handleDataUpdate(QuantumConfig.IS_CONTEXT_FORCED, b, false);
        setTimeout(() => {
          setIsPassageInContextDisabled(b);
        }, [1000]);
      }
    }))), /*#__PURE__*/React__default.createElement(View, {
      style: {
        flexDirection: "row",
        justifyContent: "space-around",
        display: "flex",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement(AppIcon
    // tooltip={"Delete snippet"}
    , {
      isClickable: true,
      onPress: deleteQ,
      icon: AppAssets.icons.delete,
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme10 = currentTheme.theme) === null || _currentTheme$theme10 === void 0 ? void 0 : _currentTheme$theme10.red
    }))), isContextForced && !isConversational && /*#__PURE__*/React__default.createElement(AppTextInput, {
      placeholder: "Context override",
      style: {
        marginTop: 2
      },
      textContainer: {
        minHeight: 120,
        paddingTop: 8,
        borderRadius: 10
      },
      type: "text",
      multiline: true,
      value: contextValue,
      onChangeText: text => {
        setContextValue(text);
        handleDataUpdate(QuantumConfig.PROMPT_PROPERTY, text, false);
      }
    }), !isConversational && /*#__PURE__*/React__default.createElement(AppTextInput, {
      placeholder: "System prompt",
      style: {
        marginTop: 2
      },
      textContainer: {
        minHeight: 120,
        paddingTop: 8,
        borderRadius: 10
      },
      type: "text",
      multiline: true,
      value: systemPromptValue,
      onChangeText: text => {
        setSystemPromptValue(text);
        handleDataUpdate(QuantumConfig.SYS_PROMPT_PROPERTY, text, false);
      }
    }), /*#__PURE__*/React__default.createElement(AppTextInput, {
      placeholder: isDPO ? "Preferred output" : "Message",
      style: {
        marginTop: 2
      },
      textContainer: {
        minHeight: 120,
        paddingTop: 8,
        borderRadius: 10
      },
      type: "text",
      multiline: true,
      value: completionValue,
      onChangeText: text => {
        setCompletionValue(text);
        handleDataUpdate(QuantumConfig.COMPLETION_TRAINED_PROPERTY, text, false);
      }
    }), isDPO && /*#__PURE__*/React__default.createElement(AppTextInput, {
      placeholder: "Non preferred output",
      style: {
        marginTop: 2
      },
      textContainer: {
        minHeight: 120,
        paddingTop: 8,
        borderRadius: 10
      },
      type: "text",
      multiline: true,
      value: nonPreferredCompletionValue,
      onChangeText: text => {
        setNonPreferredCompletionValue(text);
        handleDataUpdate(QuantumConfig.NON_PREFERRED_COMPLETION_TRAINED_PROPERTY, text, false);
      }
    }), element["IS_VALID"] === false && /*#__PURE__*/React__default.createElement(AppText, {
      style: {
        fontWeight: "bold"
      },
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme11 = currentTheme.theme) === null || _currentTheme$theme11 === void 0 ? void 0 : _currentTheme$theme11.red
    }, "Invalid snippet: the context or the completion is less than 128 characters or longer than 1200 characters.")), children)
  );
};
EditableVoidGn.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EditableVoidGn"
};

const Element = _ref => {
  var _element$children$2, _currentTheme$theme2, _currentTheme$theme4, _currentTheme$theme5, _currentTheme$theme6, _currentTheme$theme7, _currentTheme$theme8, _currentTheme$theme9, _currentTheme$theme10, _currentTheme$theme11, _currentTheme$theme12, _currentTheme$theme13, _currentTheme$theme14, _currentTheme$theme15, _currentTheme$theme16, _currentTheme$theme17, _currentTheme$theme18;
  let {
    attributes,
    children,
    element,
    trainMode,
    answerMode,
    autoAnalysisMode,
    nlpSecret,
    baseUrl,
    loggedUser,
    isAIEnabled,
    titleStyle,
    nlpConfig,
    readOnly,
    parseMode,
    isTitleEditable,
    isPlaceHolderEnabled,
    isLineByLinePlaceHolderEnabled,
    baseDocumentRedirectLink,
    trainAnswerMode,
    trainGenerationMode,
    S3downloadUrlRequest = () => {},
    workspaceid,
    fileUploadInProgress,
    imageFileNameUploadProgress,
    fileUploadProgress,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const editor = useSlate();
  const {
    indexesInContext
  } = useQuantumEditor();
  const _styles = useMemo(() => {
    return Utilities.generateStyleFromElementData(element);
  }, [element.textAlign]);
  const _toDoStyles = useMemo(() => {
    return Utilities.generateToDoStyleFromElementData(element);
  }, [element.textAlign]);
  const _textAlignmentStyles = useMemo(() => {
    return element.textAlign ? {
      textAlign: element.textAlign
    } : {};
  }, [element.textAlign]);
  const _isTextEmpty = useMemo(() => {
    var _element$children$, _element$children$$te;
    return (element === null || element === void 0 ? void 0 : (_element$children$ = element.children[0]) === null || _element$children$ === void 0 ? void 0 : (_element$children$$te = _element$children$.text) === null || _element$children$$te === void 0 ? void 0 : _element$children$$te.trim()) !== "";
  }, [element === null || element === void 0 ? void 0 : (_element$children$2 = element.children[0]) === null || _element$children$2 === void 0 ? void 0 : _element$children$2.text]);
  let isEmpty;
  if (isLineByLinePlaceHolderEnabled) {
    var _Node$string;
    const selection = editor.selection;
    if (selection !== null) Range.isCollapsed(editor.selection);
    useSelected();
    isEmpty = ((_Node$string = Node.string(element)) === null || _Node$string === void 0 ? void 0 : _Node$string.trim()) === "";
  }
  const _isElementInContext = useMemo(() => {
    const path = ReactEditor.findPath(editor, element);
    if ((path === null || path === void 0 ? void 0 : path.length) > 0 && (indexesInContext === null || indexesInContext === void 0 ? void 0 : indexesInContext.length) > 0 && indexesInContext.includes(path[0])) return true;else return false;
  }, [indexesInContext, editor, element]);
  const childrenRenderer = () => {
    var _currentTheme$theme;
    return /*#__PURE__*/React__default.createElement("li", _extends({
      style: {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.font_color,
        ..._styles,
        ..._textAlignmentStyles
      }
    }, attributes), trainMode || parseMode ? /*#__PURE__*/React__default.createElement(AppQuantumTrainingBlock, _extends({
      style: {
        ..._textAlignmentStyles
      },
      element: element,
      readOnly: readOnly,
      attributes: attributes,
      nlpConfig: nlpConfig,
      parseMode: parseMode
    }, props), children) : children);
  };
  switch (element.type) {
    case "MENTION":
      {
        return /*#__PURE__*/React__default.createElement(AppQuantumMentionComponent, {
          type: "MENTION",
          attributes: attributes,
          element: element
        }, children);
      }
    case "TAG":
      {
        return /*#__PURE__*/React__default.createElement(AppQuantumMentionComponent, {
          type: "TAG",
          attributes: attributes,
          element: element
        }, children);
      }
    case "link":
      return /*#__PURE__*/React__default.createElement(AppQuantumLink, _extends({
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.blue
        }
      }, attributes, {
        href: element.url,
        element: element
      }), children);
    case "ner":
      if (_isTextEmpty) {
        return /*#__PURE__*/React__default.createElement(AppQuantumNERComponent, {
          readOnly: readOnly,
          attributes: attributes,
          element: element
        }, children);
      } else {
        var _currentTheme$theme3;
        return /*#__PURE__*/React__default.createElement("span", _extends({
          style: {
            color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.font_color,
            ..._textAlignmentStyles
          }
        }, attributes), children);
      }
    case "block-quote":
      return /*#__PURE__*/React__default.createElement("blockquote", _extends({
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.font_color,
          ..._styles,
          ..._textAlignmentStyles
        }
      }, attributes), children);
    case "todo":
      return /*#__PURE__*/React__default.createElement(AppQuantumBlock, {
        style: {
          ..._toDoStyles,
          ..._textAlignmentStyles
        },
        element: element,
        attributes: attributes
      }, children);
    case "bulleted-list":
      return /*#__PURE__*/React__default.createElement("ul", _extends({
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.font_color,
          ..._styles,
          ..._textAlignmentStyles
        }
      }, attributes), children);
    case "title":
      return /*#__PURE__*/React__default.createElement("h1", _extends({
        // contentEditable={isTitleEditable}
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.font_color,
          backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.grey,
          padding: 10,
          marginBlockStart: 0,
          marginBlockEnd: 0,
          borderRadius: 5,
          ...titleStyle,
          ..._styles,
          ..._textAlignmentStyles
        }
      }, attributes), children);
    case "heading_one":
      return /*#__PURE__*/React__default.createElement("h1", _extends({
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.font_color,
          backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme9 = currentTheme.theme) === null || _currentTheme$theme9 === void 0 ? void 0 : _currentTheme$theme9.grey,
          padding: 10,
          fontSize: 18,
          ..._styles,
          ..._textAlignmentStyles
        }
      }, attributes), children);
    case "heading_two":
      return /*#__PURE__*/React__default.createElement("h2", _extends({
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme10 = currentTheme.theme) === null || _currentTheme$theme10 === void 0 ? void 0 : _currentTheme$theme10.font_color,
          fontSize: 18,
          padding: 5,
          ..._styles,
          ..._textAlignmentStyles
        }
      }, attributes), children);
    case "heading_three":
      return /*#__PURE__*/React__default.createElement("h3", _extends({
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme11 = currentTheme.theme) === null || _currentTheme$theme11 === void 0 ? void 0 : _currentTheme$theme11.font_color,
          fontSize: 17,
          padding: 3,
          ..._styles,
          ..._textAlignmentStyles
        }
      }, attributes), children);
    case "heading_four":
      return /*#__PURE__*/React__default.createElement("h4", _extends({
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme12 = currentTheme.theme) === null || _currentTheme$theme12 === void 0 ? void 0 : _currentTheme$theme12.font_color,
          fontSize: 16,
          padding: 2,
          ..._styles,
          ..._textAlignmentStyles
        }
      }, attributes), children);
    case "heading_five":
      return /*#__PURE__*/React__default.createElement("h5", _extends({
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme13 = currentTheme.theme) === null || _currentTheme$theme13 === void 0 ? void 0 : _currentTheme$theme13.font_color,
          fontSize: 16,
          padding: 1,
          ..._styles,
          ..._textAlignmentStyles
        }
      }, attributes), children);
    case "heading_six":
      return /*#__PURE__*/React__default.createElement("h6", _extends({
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme14 = currentTheme.theme) === null || _currentTheme$theme14 === void 0 ? void 0 : _currentTheme$theme14.font_color,
          ..._styles,
          ..._textAlignmentStyles
        }
      }, attributes), children);
    case "list-item":
      return childrenRenderer();
    case "numbered-list":
      return /*#__PURE__*/React__default.createElement("ol", _extends({
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme15 = currentTheme.theme) === null || _currentTheme$theme15 === void 0 ? void 0 : _currentTheme$theme15.font_color,
          ..._styles,
          ..._textAlignmentStyles
        }
      }, attributes), children);
    case "image":
      return /*#__PURE__*/React__default.createElement(ImageElement, {
        fileUploadInProgress: fileUploadInProgress,
        imageFileNameUploadProgress: imageFileNameUploadProgress,
        fileUploadProgress: fileUploadProgress,
        attributes: attributes,
        children: children,
        element: element,
        S3downloadUrlRequest: S3downloadUrlRequest,
        workspaceid: workspaceid
      });
    case "table":
      return /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("tbody", attributes, children));
    case "table-row":
      return /*#__PURE__*/React__default.createElement("tr", attributes, children);
    case "table-cell":
      return /*#__PURE__*/React__default.createElement("td", attributes, children);
    case "editable-void":
      if (trainAnswerMode) return /*#__PURE__*/React__default.createElement(EditableVoid, _extends({
        element: element
      }, attributes), children);else if (trainGenerationMode) return /*#__PURE__*/React__default.createElement(EditableVoidGn, _extends({
        element: element
      }, attributes), children);else return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
    default:
      return trainMode || parseMode ? /*#__PURE__*/React__default.createElement(AppQuantumTrainingBlock, {
        style: {
          ..._textAlignmentStyles
        },
        element: element,
        readOnly: readOnly,
        attributes: attributes,
        nlpConfig: nlpConfig,
        parseMode: parseMode
      }, children) : autoAnalysisMode ? /*#__PURE__*/React__default.createElement(AppQuantumAutoNLPBlock, {
        isAIEnabled: isAIEnabled,
        style: {
          ..._textAlignmentStyles
        },
        element: element,
        attributes: attributes,
        nlpSecret: nlpSecret,
        baseUrl: baseUrl,
        loggedUser: loggedUser,
        nlpConfig: nlpConfig
      }, children) : answerMode ? /*#__PURE__*/React__default.createElement(AppQuantumAQuestionBlock, {
        isAIEnabled: isAIEnabled,
        baseDocumentRedirectLink: baseDocumentRedirectLink,
        style: {
          ..._textAlignmentStyles
        },
        element: element,
        attributes: attributes,
        nlpSecret: nlpSecret,
        baseUrl: baseUrl,
        loggedUser: loggedUser,
        nlpConfig: nlpConfig
      }, children) : /*#__PURE__*/React__default.createElement("p", _extends({
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme16 = currentTheme.theme) === null || _currentTheme$theme16 === void 0 ? void 0 : _currentTheme$theme16.font_color,
          backgroundColor: _isElementInContext && (trainAnswerMode || trainGenerationMode) ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme17 = currentTheme.theme) === null || _currentTheme$theme17 === void 0 ? void 0 : _currentTheme$theme17.primary : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme18 = currentTheme.theme) === null || _currentTheme$theme18 === void 0 ? void 0 : _currentTheme$theme18.transparent,
          marginTop: 10,
          ..._styles,
          ..._textAlignmentStyles
        }
      }, attributes, {
        className: (isLineByLinePlaceHolderEnabled && selected || !isLineByLinePlaceHolderEnabled) && isEmpty && isSelectionCollapsed && (isLineByLinePlaceHolderEnabled || isPlaceHolderEnabled && ReactEditor.findPath(editor, element)[0] === 1 && editor.children.length === 2) ? "selected-empty-element" : ""
      }), children);
  }
};
Element.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Element",
  "props": {
    "S3downloadUrlRequest": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

const QuantumNerLeaf = _ref => {
  var _currentTheme$theme, _currentTheme$theme2;
  let {
    ner,
    readOnly,
    mode,
    currentTheme,
    children,
    attributes
  } = _ref;
  const editor = useSlate();
  const [isMouseHover, setIsMouseHover] = useState(false);
  const [isMouseHoverDelete, setIsMouseHoverDelete] = useState(false);
  const selected = useSelected();
  const focused = useFocused();
  const _styleLabelBackground = isMouseHover ? "".concat(ner === null || ner === void 0 ? void 0 : ner.backgroundColor, "99") : "".concat(ner === null || ner === void 0 ? void 0 : ner.backgroundColor, "80");
  const _styles = styleGenerator$4(currentTheme, isMouseHover, isMouseHoverDelete, 18, _styleLabelBackground, selected, focused);
  const isClicked = (editor === null || editor === void 0 ? void 0 : editor.selection) && Range.isCollapsed(editor === null || editor === void 0 ? void 0 : editor.selection) && isMouseHover && !readOnly;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("mark", {
    onMouseLeave: () => setIsMouseHover(false),
    "data-tooltip": ner.label,
    "data-tooltip-position": "top"
    // add a tooltip here
    ,
    onClick: () => setIsMouseHover(true),
    attributes: attributes,
    style: {
      backgroundColor: ner === null || ner === void 0 ? void 0 : ner.backgroundColor,
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.white,
      paddingLeft: 5,
      paddingRight: 5,
      borderRadius: 5,
      cursor: "pointer"
    }
  }, children), isClicked && /*#__PURE__*/React__default.createElement("div", {
    onMouseEnter: () => setIsMouseHover(true),
    onMouseLeave: () => setIsMouseHover(false),
    style: {
      position: "absolute",
      display: "initial",
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.darkGrey
    },
    contentEditable: false,
    readOnly: true
  }, /*#__PURE__*/React__default.createElement("span", {
    id: "nerDesc",
    contentEditable: false,
    readOnly: true,
    style: _styles.descrLabel
  }, ner.label), /*#__PURE__*/React__default.createElement("span", {
    id: "nerRemove",
    contentEditable: false,
    readOnly: true,
    onClick: () => {
      var _editor$selection, _editor$selection2, _children$props, _children$props$text, _children$props$text$;
      ({
        ...(editor === null || editor === void 0 ? void 0 : editor.selection)
      });
      //   set selection to the whole mark
      Transforms.select(editor, {
        anchor: {
          path: editor === null || editor === void 0 ? void 0 : (_editor$selection = editor.selection) === null || _editor$selection === void 0 ? void 0 : _editor$selection.anchor.path,
          offset: 0
        },
        focus: {
          path: editor === null || editor === void 0 ? void 0 : (_editor$selection2 = editor.selection) === null || _editor$selection2 === void 0 ? void 0 : _editor$selection2.focus.path,
          offset: children === null || children === void 0 ? void 0 : (_children$props = children.props) === null || _children$props === void 0 ? void 0 : (_children$props$text = _children$props.text) === null || _children$props$text === void 0 ? void 0 : (_children$props$text$ = _children$props$text.text) === null || _children$props$text$ === void 0 ? void 0 : _children$props$text$.length
        }
      });
      Editor.removeMark(editor, ner.label);
      Editor.removeMark(editor, "type");
    },
    style: _styles.decDeleteIcon
  }, "\xD7")));
};
const styleGenerator$4 = (props, isMouseHover, isMouseHoverDelete, size, color, selected, focused) => {
  var _props$theme, _props$theme2, _props$theme3, _props$theme4, _props$theme5;
  return {
    decLabel: {
      color: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.font_color,
      paddingLeft: 3,
      paddingRight: 3,
      backgroundColor: color || "inherit",
      borderRadius: 5,
      boxShadow: selected && focused ? "0 0 0 2px #B4D5FF" : "none",
      borderWidth: 1,
      cursor: "pointer"
    },
    decDeleteIcon: {
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.red,
      color: props === null || props === void 0 ? void 0 : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.white,
      textAlign: "center",
      opacity: isMouseHover || isMouseHoverDelete || selected ? 1 : 0,
      position: "absolute",
      // marginTop: "-11px",
      // marginLeft: (-1 * size) / 2,
      width: size,
      height: 19,
      borderTopRightRadius: 2,
      borderBottomRightRadius: 2,
      paddingHorizontal: 2,
      verticalAlign: "center",
      MozUserSelect: "-moz-none",
      KhtmlUserSelect: "none",
      WebkitUserSelect: "none",
      userSelect: "none",
      cursor: "pointer"
    },
    descrLabel: {
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.darkGrey,
      color: props === null || props === void 0 ? void 0 : (_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : _props$theme5.lightGrey,
      textAlign: "center",
      opacity: isMouseHover || isMouseHoverDelete || selected ? 1 : 0,
      // position: "absolute",
      marginTop: "-11px",
      // marginLeft: "-10px",
      // marginRight: "2px",
      paddingLeft: "5px",
      paddingRight: "5px",
      // width: size,
      // height: size,
      // borderRadius: 2,
      paddingHorizontal: 2,
      verticalAlign: "center",
      MozUserSelect: "-moz-none",
      KhtmlUserSelect: "none",
      WebkitUserSelect: "none",
      userSelect: "none",
      cursor: "pointer"
    }
  };
};
QuantumNerLeaf.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "QuantumNerLeaf"
};

const Leaf = _ref => {
  var _currentTheme$theme, _leaf$data, _leaf$data2;
  let {
    attributes,
    children,
    leaf,
    NERStyles,
    readOnly
  } = _ref;
  const {
    currentTheme,
    mode
  } = useTheme();
  const editor = useSlate();
  const searchedTextStyle = leaf.highlight ? {
    backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.yellow
  } : {};
  if (leaf.bold) {
    children = /*#__PURE__*/React__default.createElement("strong", {
      style: {
        ...searchedTextStyle
      }
    }, children);
  }
  for (const i in NERStyles) {
    const ner = NERStyles[i];
    if (leaf[ner.label]) {
      children = /*#__PURE__*/React__default.createElement(QuantumNerLeaf, {
        mode: mode,
        currentTheme: currentTheme,
        editor: editor,
        ner: ner,
        leaf: leaf,
        readOnly: readOnly,
        attributes: attributes
      }, children);
      break;
    }
  }
  if (leaf.highlightRed) {
    var _currentTheme$theme2;
    children = /*#__PURE__*/React__default.createElement("mark", {
      "data-highlight-color": "red",
      style: {
        backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.red,
        color: "inherit",
        ...searchedTextStyle
      }
    }, children);
  }
  if (leaf.highlightGreen) {
    var _currentTheme$theme3;
    children = /*#__PURE__*/React__default.createElement("mark", {
      "data-highlight-color": "green",
      style: {
        backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.green,
        color: "inherit",
        ...searchedTextStyle
      }
    }, children);
  }
  if (leaf.highlightYellow) {
    var _currentTheme$theme4;
    children = /*#__PURE__*/React__default.createElement("mark", {
      "data-highlight-color": "yellow",
      style: {
        backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.yellow,
        color: "inherit",
        ...searchedTextStyle
      }
    }, children);
  }
  if (leaf.highlightBlue) {
    var _currentTheme$theme5;
    children = /*#__PURE__*/React__default.createElement("mark", {
      "data-highlight-color": "blue",
      style: {
        backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.blue,
        color: "inherit",
        ...searchedTextStyle
      }
    }, children);
  }
  if (leaf.fontRed) {
    var _currentTheme$theme6;
    children = /*#__PURE__*/React__default.createElement("span", {
      "data-font-color": "red",
      style: {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.red,
        ...searchedTextStyle
      }
    }, children);
  }
  if (leaf.fontGreen) {
    var _currentTheme$theme7;
    children = /*#__PURE__*/React__default.createElement("span", {
      "data-font-color": "green",
      style: {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.green,
        ...searchedTextStyle
      }
    }, children);
  }
  if (leaf.fontYellow) {
    var _currentTheme$theme8;
    children = /*#__PURE__*/React__default.createElement("span", {
      "data-font-color": "yellow",
      style: {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.yellow,
        ...searchedTextStyle
      }
    }, children);
  }
  if (leaf.fontBlue) {
    var _currentTheme$theme9;
    children = /*#__PURE__*/React__default.createElement("span", {
      "data-font-color": "blue",
      style: {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme9 = currentTheme.theme) === null || _currentTheme$theme9 === void 0 ? void 0 : _currentTheme$theme9.blue,
        ...searchedTextStyle
      }
    }, children);
  }
  if (leaf.code) {
    children = /*#__PURE__*/React__default.createElement("code", {
      style: {
        ...searchedTextStyle
      }
    }, children);
  }
  if (leaf.italic) {
    children = /*#__PURE__*/React__default.createElement("em", {
      style: {
        ...searchedTextStyle
      }
    }, children);
  }
  if (leaf.underline) {
    children = /*#__PURE__*/React__default.createElement("u", {
      style: {
        ...searchedTextStyle
      }
    }, children);
  }
  if ((_leaf$data = leaf.data) !== null && _leaf$data !== void 0 && _leaf$data.name && (_leaf$data2 = leaf.data) !== null && _leaf$data2 !== void 0 && _leaf$data2.alphaColor && leaf.isCaret) {
    var _leaf$data3, _leaf$data4, _leaf$data5;
    children = /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "inline-block"
      },
      contentEditable: false
    }, /*#__PURE__*/React__default.createElement("span", {
      contentEditable: false,
      style: {
        backgroundColor: leaf === null || leaf === void 0 ? void 0 : (_leaf$data3 = leaf.data) === null || _leaf$data3 === void 0 ? void 0 : _leaf$data3.alphaColor,
        position: "absolute",
        padding: "4px 8px",
        marginTop: "-14px",
        fontSize: "12px",
        display: "inline-block",
        fontWeight: "normal",
        fontFamily: "normalFont"
      }
    }, (_leaf$data4 = leaf.data) === null || _leaf$data4 === void 0 ? void 0 : _leaf$data4.name), /*#__PURE__*/React__default.createElement("span", {
      style: {
        backgroundColor: leaf === null || leaf === void 0 ? void 0 : (_leaf$data5 = leaf.data) === null || _leaf$data5 === void 0 ? void 0 : _leaf$data5.alphaColor,
        width: "2px",
        height: "18px",
        display: "inline-block",
        position: "absolute"
      },
      contentEditable: false
    }), children);
  }
  if ((leaf === null || leaf === void 0 ? void 0 : leaf.type) === "link" && leaf !== null && leaf !== void 0 && leaf.url) {
    var _currentTheme$theme10;
    children = /*#__PURE__*/React__default.createElement("a", _extends({
      style: {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme10 = currentTheme.theme) === null || _currentTheme$theme10 === void 0 ? void 0 : _currentTheme$theme10.primary,
        cursor: "pointer"
      }
    }, attributes, {
      href: leaf === null || leaf === void 0 ? void 0 : leaf.url,
      onClick: e => {
        e.preventDefault();
        window.open(leaf === null || leaf === void 0 ? void 0 : leaf.url, "_blank");
      }
    }), children);
  }
  return /*#__PURE__*/React__default.createElement("span", _extends({}, attributes, {
    style: {
      ...searchedTextStyle
    }
  }), children);
};
Leaf.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Leaf"
};

const AppHorizontalView = _ref => {
  let {
    children,
    style,
    ...props
  } = _ref;
  useTheme();
  const _styles = generateStyle();
  return /*#__PURE__*/React__default.createElement(AppFadeView, _extends({}, props, {
    style: [_styles.toolBarWrapper, style]
  }), children);
};
const generateStyle = props => {
  return StyleSheet.create({
    toolBarWrapper: {
      flexDirection: "row",
      marginBottom: 5,
      paddingVertical: 5
    }
  });
};
AppHorizontalView.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppHorizontalView",
  "props": {
    "children": {
      "required": false,
      "tsType": {
        "name": "ReactNode"
      },
      "description": "Children prop"
    },
    "style": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style prop\n@default {}"
    }
  }
};

const AppButtonMultipleSelection = _ref => {
  var _currentTheme$theme;
  let {
    icon,
    isActive = false,
    subOptions,
    onPress,
    onOptionPress,
    subOptionsModalStyle,
    subOptionsIconStyle,
    iconSize = 14,
    isMenuVisible,
    readOnly,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const [target, setTarget] = useState({
    top: 0,
    left: 0
  });
  const styles = styleGenerator$3(currentTheme, target);
  return /*#__PURE__*/React__default.createElement(View, {
    style: styles.container
  }, /*#__PURE__*/React__default.createElement(AppIcon, _extends({
    onLayout: event => {
      const layout = event.nativeEvent.layout;
      setTarget(layout);
    },
    color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.font_color,
    isClickable: !readOnly,
    icon: icon,
    isActive: isActive,
    onPress: onPress,
    size: iconSize,
    style: styles.icon
  }, props)), /*#__PURE__*/React__default.createElement(AppModal, {
    transparent: true,
    modalStyle: [styles.modalStyle, subOptionsModalStyle],
    closeModal: onPress,
    isModalVisible: isMenuVisible
  }, /*#__PURE__*/React__default.createElement(AppHorizontalView, null, subOptions === null || subOptions === void 0 ? void 0 : subOptions.map(c => /*#__PURE__*/React__default.createElement(AppIcon, {
    key: c.id,
    size: 20,
    style: [styles.icon, subOptionsIconStyle],
    isClickable: true,
    onPress: event => onOptionPress(event, c),
    icon: c.icon,
    color: c.color
  })))));
};
const styleGenerator$3 = (currentTheme, target) => {
  var _currentTheme$theme2;
  return StyleSheet.create({
    container: {
      alignItems: "center"
    },
    icon: {
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.lightGrey,
      borderRadius: 5,
      height: 20,
      marginRight: 5,
      paddingVertical: 5,
      width: 30
    },
    label: {
      marginTop: 3,
      fontSize: 10,
      fontWeight: "bold"
    },
    modalStyle: {
      margin: "auto",
      position: "absolute",
      top: (target === null || target === void 0 ? void 0 : target.top) + (target === null || target === void 0 ? void 0 : target.height),
      left: target === null || target === void 0 ? void 0 : target.left,
      flexGrow: 0,
      borderRadius: 10,
      alignItems: "center",
      justifyContent: "center"
    }
  });
};
AppButtonMultipleSelection.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppButtonMultipleSelection",
  "props": {
    "isActive": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the icon color changes depending on the theme selected"
    },
    "iconSize": {
      "defaultValue": {
        "value": "14",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Sets the size of the trigger icon"
    },
    "icon": {
      "required": true,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": "Icon displayed as trigger for the selection modal"
    },
    "subOptions": {
      "required": false,
      "tsType": {
        "name": "Array",
        "elements": [{
          "name": "any"
        }],
        "raw": "any[]"
      },
      "description": "List of items used to populate the sub-selection"
    },
    "onPress": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Event raised when the trigger icon is pressed"
    },
    "onOptionPress": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(e: any, item: any) => void",
        "signature": {
          "arguments": [{
            "name": "e",
            "type": {
              "name": "any"
            }
          }, {
            "name": "item",
            "type": {
              "name": "any"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Event raised when the sub-option icon is pressed"
    },
    "subOptionsModalStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style of view wrapping all sub-options in modal"
    },
    "subOptionsIconStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style of icons used for sub-options"
    },
    "isMenuVisible": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the sub-options become visible"
    },
    "readOnly": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the icon cannot be clicked"
    }
  }
};

const withImages = editor => {
  const {
    insertData,
    isVoid
  } = editor;
  editor.isVoid = element => {
    return element.type === "image" ? true : isVoid(element);
  };
  editor.insertData = data => {
    const text = data.getData("text/plain");
    const {
      files
    } = data;
    if (files && files.length > 0) {
      for (const file of files) {
        const reader = new FileReader();
        const [mime] = file.type.split("/");
        if (mime === "image") {
          reader.addEventListener("load", () => {
            const url = reader.result;
            insertImage(editor, url);
          });
          reader.readAsDataURL(file);
        }
      }
    } else if (isImageUrl(text)) {
      insertImage(editor, text);
    } else {
      insertData(data);
    }
  };
  return editor;
};
const insertImage = function (editor, url, isPrivate, fileType) {
  let isLoading = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  const text = {
    text: ""
  };
  const image = {
    type: "image",
    url,
    children: [text],
    isPrivate,
    fileType,
    isLoading
  };
  const paragraph = {
    type: "paragraph",
    children: [{
      text: ""
    }]
  };
  Transforms.insertNodes(editor, [image, paragraph]);
};
const updateImage = (editor, url) => {
  for (const [node, path] of Editor.nodes(editor, {
    at: [],
    match: n => n.url === url
  })) {
    if (node.type === "image") {
      const updatedNode = {
        ...node,
        isLoading: false
      };
      Transforms.setNodes(editor, updatedNode, {
        at: path
      });
    }
  }
};
const isImageUrl = url => {
  if (!url) return false;
  if (!isUrl(url)) return false;
  const ext = new URL(url).pathname.split(".").pop();
  return imageExtensions.includes(ext);
};

let savedSelection;
function saveSelection() {
  if (window.getSelection) {
    savedSelection = window.getSelection().getRangeAt(0);
  }
}
function restoreSelection() {
  if (window.getSelection) {
    let sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(savedSelection);
  }
}

// create a function that gets as a parameter another function with the ability to pass any parameter
function withSaveRestoreSelection(func) {
  saveSelection();
  // Call the passed function with its arguments and wait for it to finish.
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  func(...args);
  restoreSelection();
}
const BlockButton = _ref => {
  let {
    format,
    icon,
    blockType,
    readOnly
  } = _ref;
  const editor = useSlate();
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator$2(currentTheme);
  const _coreComponent = useMemo(() => {
    var _currentTheme$theme;
    return /*#__PURE__*/React__default.createElement(AppIcon, {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.font_color,
      isClickable: !readOnly,
      icon: icon,
      isActive: format === blockType,
      onPress: event => {
        withSaveRestoreSelection(Utilities.toggleBlock, editor, format);
      },
      size: 14,
      style: styles.icon
    });
  }, [format, blockType, currentTheme, readOnly]);
  return /*#__PURE__*/React__default.createElement(View, {
    style: styles.container
  }, _coreComponent);
};
const ACG = _ref2 => {
  var _fakeCheckData$conten, _fakeCheckData$conten2, _fakeCheckData$conten3, _fakeCheckData$conten4, _fakeCheckData$conten5;
  let {
    agcEnabled,
    handleCheckOnFakeData,
    fakeCheckData,
    fakeCheckInProgress
  } = _ref2;
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator$2(currentTheme);
  const fakePercentage = (fakeCheckData === null || fakeCheckData === void 0 ? void 0 : (_fakeCheckData$conten = fakeCheckData.contents) === null || _fakeCheckData$conten === void 0 ? void 0 : _fakeCheckData$conten.length) > 0 && (fakeCheckData === null || fakeCheckData === void 0 ? void 0 : (_fakeCheckData$conten2 = fakeCheckData.contents[0]) === null || _fakeCheckData$conten2 === void 0 ? void 0 : (_fakeCheckData$conten3 = _fakeCheckData$conten2.output) === null || _fakeCheckData$conten3 === void 0 ? void 0 : (_fakeCheckData$conten4 = _fakeCheckData$conten3.fake_probability) === null || _fakeCheckData$conten4 === void 0 ? void 0 : _fakeCheckData$conten4.toFixed(2));
  // generate a string from fakeCheckData?.contents[0]?.output?.fake_probability with max 2 decimals
  const fakeCheckDataString = (fakeCheckData === null || fakeCheckData === void 0 ? void 0 : (_fakeCheckData$conten5 = fakeCheckData.contents) === null || _fakeCheckData$conten5 === void 0 ? void 0 : _fakeCheckData$conten5.length) > 0 ? "".concat((fakePercentage * 100).toFixed(0), " %") : "0 %";
  const mapColorToPercentage = percentage => {
    if (!percentage) return currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme["darkGrey"];
    if (percentage < 0.3) return currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme["green"];
    if (percentage < 0.75) return currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme["orange"];
    return currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme["red"];
  };
  const _coreComponent = useMemo(() => {
    var _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5;
    return /*#__PURE__*/React__default.createElement(View, {
      style: {
        flexDirection: "row",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.primary,
      isClickable: agcEnabled,
      icon: AppAssets.icons.acg,
      onPress: event => {
        event.preventDefault();
        handleCheckOnFakeData();
      },
      size: 24,
      style: styles.icon
      // tooltip="Artificial Content Index"
    }), fakeCheckInProgress ? /*#__PURE__*/React__default.createElement(AppSpinner, {
      containerStyle: {
        alignItems: "flex-start"
      },
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.transparent,
      size: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.medium_font_size
    }) : /*#__PURE__*/React__default.createElement(AppText, {
      wrapperStyle: {
        minWidth: 55,
        marginTop: 0
      },
      style: {
        fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.large_font_size
      },
      fontWeight: "bold",
      color: mapColorToPercentage(fakePercentage)
    }, fakeCheckDataString));
  }, [agcEnabled, currentTheme, fakeCheckDataString, fakePercentage, handleCheckOnFakeData]);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [styles.container]
  }, _coreComponent);
};
const RECORDER = _ref3 => {
  let {
    allowTranscription,
    onRecordClick
  } = _ref3;
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator$2(currentTheme);
  const [isRecording, setIsRecording] = useState(false);
  const mapColorToState = () => {
    if (isRecording) return currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme["red"];else return currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme["primary"];
  };
  const stopRecording = event => {
    event.preventDefault();
    const newState = !isRecording;
    setIsRecording(newState);
    onRecordClick(newState);
  };
  const _coreComponent = useMemo(() => {
    var _AppAssets$icons;
    return /*#__PURE__*/React__default.createElement(View, {
      style: {
        flexDirection: "row",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      color: mapColorToState(),
      isClickable: allowTranscription,
      icon: isRecording ? AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons = AppAssets.icons) === null || _AppAssets$icons === void 0 ? void 0 : _AppAssets$icons.stopGeneration : AppAssets.icons.microphone,
      onPress: stopRecording,
      size: 20,
      style: styles.icon
      // tooltip="Artificial Content Index"
    }));
  }, [isRecording, currentTheme, allowTranscription]);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [styles.container]
  }, _coreComponent);
};
const TextAlignButton = _ref4 => {
  let {
    alignment,
    icon,
    label,
    currentAlignment,
    readOnly
  } = _ref4;
  const editor = useSlate();
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator$2(currentTheme);
  const _coreComponent = useMemo(() => {
    var _currentTheme$theme6;
    /*#__PURE__*/React__default.createElement(AppIcon, {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.font_color,
      isClickable: !readOnly,
      icon: icon,
      isActive: currentAlignment === alignment || !currentAlignment && alignment === "left",
      onPress: event => {
        withSaveRestoreSelection(Utilities.toogleTextAlign, editor, alignment);
      },
      size: 14,
      style: styles.icon
    });
  }, [currentTheme, readOnly, currentAlignment, alignment, icon]);
  return /*#__PURE__*/React__default.createElement(View, {
    style: styles.container
  }, _coreComponent);
};
const MarkButton = _ref5 => {
  let {
    format,
    icon,
    label,
    subOptions,
    marks,
    readOnly
  } = _ref5;
  const editor = useSlate();
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator$2(currentTheme);
  const [isMenuVisible, setMenuVisible] = useState(false);
  const _coreComponent = useMemo(() => {
    return /*#__PURE__*/React__default.createElement(AppButtonMultipleSelection, {
      readOnly: readOnly,
      isMenuVisible: isMenuVisible,
      onPress: event => {
        saveSelection();
        event === null || event === void 0 ? void 0 : event.preventDefault();
        if ((subOptions === null || subOptions === void 0 ? void 0 : subOptions.length) > 0) setMenuVisible(!isMenuVisible);else Utilities.toggleMark(editor, format);
        restoreSelection();
      },
      subOptions: subOptions,
      icon: icon,
      isActive: Utilities.isMarkActiveOptimised(editor, format, marks),
      onOptionPress: (event, c) => {
        withSaveRestoreSelection(Utilities.toggleMark, editor, c.format);
      }
    });
  }, [isMenuVisible, readOnly, subOptions, editor, format, marks]);
  return /*#__PURE__*/React__default.createElement(View, {
    style: styles.container,
    accessibilityLabel: label
  }, _coreComponent);
};
const LinkButton = _ref6 => {
  let {
    _label,
    readOnly
  } = _ref6;
  const editor = useSlate();
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator$2(currentTheme);
  const _coreComponent = useMemo(() => {
    var _currentTheme$theme7;
    return /*#__PURE__*/React__default.createElement(AppIcon, {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.font_color,
      icon: AppAssets.icons.link,
      size: 14,
      isClickable: !readOnly
      // isActive={isLinkActive(editor)}
      ,
      onPress: event => {
        saveSelection();
        const url = window.prompt("Enter the URL of the link:");
        if (!url) return;
        Editor.addMark(editor, "url", url);
        Editor.addMark(editor, "type", "link");

        // Get the parent paragraph/block node of the selection
        const parent = Editor.parent(editor, editor.selection.focus.path);

        // Get the text content of the paragraph/block node
        Editor.string(editor, parent[1]);
        // Get the text content of the selection
        Editor.string(editor, editor.selection);
        // Check if the selection text is at the end of the paragraph/block text
        // if (parentText.endsWith(selectionText)) {
        //   // If it is, insert a space at the selection
        //   Editor.insertText(editor, " ");
        // }
        restoreSelection();
      },
      style: styles.icon
    });
  }, [readOnly, editor, currentTheme]);
  return /*#__PURE__*/React__default.createElement(View, {
    style: styles.container
  }, _coreComponent);
};
const ImageButton = _ref7 => {
  let {
    _label,
    readOnly,
    allowUrl,
    S3uploadUrlRequest = async () => {},
    fileUploadInProgress,
    setFileUploadInProgress,
    setImageFileNameUploadProgress,
    setFileUploadProgress,
    workspaceid
  } = _ref7;
  const editor = useSlate();
  const inputRef = useRef(null);
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator$2(currentTheme);
  const handleFileChange = async event => {
    var _JSON$parse;
    const file = event.target.files[0];
    if (!file) return;
    // Extract the file name and extension
    // generate a random file name
    const filename = file.name;
    const _fileN = String(Date.now()) + filename;
    const contentType = filename.slice((Math.max(0, filename.lastIndexOf(".")) || Infinity) + 1);
    insertImage(editor, _fileN, true, file.type, true);
    const result = await S3uploadUrlRequest({
      filename: "".concat(workspaceid, "/").concat(_fileN),
      importType: "imported-image",
      contentType
    });
    await axios.request({
      method: "put",
      url: (_JSON$parse = JSON.parse(result === null || result === void 0 ? void 0 : result.body)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.uploadURL,
      data: file,
      headers: {
        "Content-Type": file.type
      },
      onUploadProgress: p => {
        setFileUploadInProgress(true);
        setImageFileNameUploadProgress(_fileN);
        setFileUploadProgress(Math.round(p.loaded * 100 / p.total));
        if (p.loaded === p.total) {
          setFileUploadInProgress(false);
          setImageFileNameUploadProgress(null);
        }
      }
    });
    if (JSON.parse(result === null || result === void 0 ? void 0 : result.body).uploadURL) {
      // const url = JSON.parse(result?.body).uploadURL;
      // Insert the URL into the editor.
      updateImage(editor, _fileN);
    }
  };
  const handleClick = () => {
    if (!readOnly) {
      inputRef.current.click();
    }
  };
  const _coreComponent = useMemo(() => {
    var _currentTheme$theme8;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("input", {
      type: "file",
      style: {
        display: "none"
      },
      ref: inputRef,
      onChange: handleFileChange,
      accept: ".png,.jpg,.jpeg"
    }), /*#__PURE__*/React__default.createElement(AppIcon, {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.font_color,
      icon: AppAssets.icons.image,
      isClickable: !readOnly && !fileUploadInProgress
      // isActive={isLinkActive(editor)}
      ,
      onPress: event => {
        if (allowUrl) {
          event.preventDefault();
          const url = window.prompt("Enter the URL of the image:");
          if (url && !isImageUrl(url)) {
            alert("URL is not an image");
            return;
          }
          url && insertImage(editor, url);
        } else {
          handleClick();
        }
      },
      size: 14,
      style: styles.icon
    }));
  }, [readOnly, editor, currentTheme]);
  return /*#__PURE__*/React__default.createElement(View, {
    style: styles.container
  }, _coreComponent);
};
const RemoveLinkButton = _ref8 => {
  var _currentTheme$theme9;
  let {
    label,
    readOnly
  } = _ref8;
  const editor = useSlate();
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator$2(currentTheme);
  return /*#__PURE__*/React__default.createElement(View, {
    style: styles.container
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme9 = currentTheme.theme) === null || _currentTheme$theme9 === void 0 ? void 0 : _currentTheme$theme9.font_color,
    icon: AppAssets.icons.unlink,
    isClickable: !readOnly
    // isActive={isLinkActive(editor)}
    ,
    onPress: event => {
      saveSelection();
      Editor.removeMark(editor, "url");
      Editor.removeMark(editor, "type");
      restoreSelection();
    },
    size: 14,
    style: styles.icon
  }));
};
const styleGenerator$2 = (currentTheme, target) => {
  var _currentTheme$theme10;
  return StyleSheet.create({
    container: {
      alignItems: "center"
    },
    icon: {
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme10 = currentTheme.theme) === null || _currentTheme$theme10 === void 0 ? void 0 : _currentTheme$theme10.lightGrey,
      borderRadius: 5,
      height: 20,
      marginRight: 5,
      paddingVertical: 5,
      width: 30
    },
    label: {
      marginTop: 3,
      fontSize: 10,
      fontWeight: "bold"
    },
    modalStyle: {
      margin: "auto",
      position: "absolute",
      top: (target === null || target === void 0 ? void 0 : target.top) + (target === null || target === void 0 ? void 0 : target.height),
      left: target === null || target === void 0 ? void 0 : target.left,
      flexGrow: 0,
      borderRadius: 10,
      alignItems: "center",
      justifyContent: "center"
    }
  });
};
BlockButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BlockButton"
};
ACG.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ACG"
};
RECORDER.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RECORDER"
};
TextAlignButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TextAlignButton"
};
MarkButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MarkButton"
};
LinkButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LinkButton"
};
ImageButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ImageButton",
  "props": {
    "S3uploadUrlRequest": {
      "defaultValue": {
        "value": "async () => {}",
        "computed": false
      },
      "required": false
    }
  }
};
RemoveLinkButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RemoveLinkButton"
};

const AppQuantumCounter = _ref => {
  let {
    maxWords,
    words,
    maxCharacters,
    characters
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const remainingWords = maxWords - (words || 0);
  const remainingCharacters = maxCharacters - (characters || 0);
  return /*#__PURE__*/React__default.createElement(View, {
    style: {
      paddingTop: 5,
      position: "relative",
      bottom: 0
    }
  }, maxWords && /*#__PURE__*/React__default.createElement(AppText, {
    color: currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme[remainingWords > 0 ? "mediumGrey" : "red"]
  }, "Remaining words: ".concat(remainingWords)), maxCharacters && /*#__PURE__*/React__default.createElement(AppText, {
    color: currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme[remainingWords > 0 ? "mediumGrey" : "red"]
  }, "Remaining characters: ".concat(remainingCharacters)));
};
AppQuantumCounter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumCounter"
};

const AppQuantumEditorToolbar = _ref => {
  let {
    marks,
    alignment,
    blockType,
    readOnly,
    agcEnabled,
    handleCheckOnFakeData,
    fakeCheckData,
    acgShownInFixedTitle,
    fakeCheckInProgress,
    allowTranscription,
    onRecordClick,
    allowImages,
    S3uploadUrlRequest,
    setFileUploadInProgress,
    setImageFileNameUploadProgress,
    imageFileNameUploadProgress,
    setFileUploadProgress,
    workspaceid
  } = _ref;
  // get the dimensions of the screen
  const dimensions = useWindowDimensions();
  return /*#__PURE__*/React__default.createElement(AppHorizontalView, {
    style: {
      justifyContent: "space-between",
      flexDirection: "row",
      alignItems: "center",
      overflow: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "row",
      alignItems: "center",
      maxWidth: (dimensions === null || dimensions === void 0 ? void 0 : dimensions.width) - 65
    }
  }, /*#__PURE__*/React__default.createElement(MarkButton, {
    readOnly: readOnly,
    format: "bold",
    icon: AppAssets.icons.bold,
    label: "Bold",
    marks: marks
  }), /*#__PURE__*/React__default.createElement(MarkButton, {
    readOnly: readOnly,
    format: "italic",
    icon: AppAssets.icons.italic,
    label: "Italic",
    marks: marks
  }), /*#__PURE__*/React__default.createElement(MarkButton, {
    readOnly: readOnly,
    format: "underline",
    icon: AppAssets.icons.underlined,
    label: "Underline",
    marks: marks
  }), /*#__PURE__*/React__default.createElement(MarkButton, {
    readOnly: readOnly,
    format: "code",
    icon: AppAssets.icons.code,
    label: "Code",
    marks: marks
  }), /*#__PURE__*/React__default.createElement(MarkButton, {
    readOnly: readOnly,
    subOptions: QuantumConfig.FONT_COLOURS,
    icon: AppAssets.icons.fontColor,
    label: "FontColor",
    subOptionsProperty: "FONT_COLOURS",
    marks: marks
  }), /*#__PURE__*/React__default.createElement(MarkButton, {
    readOnly: readOnly,
    subOptions: QuantumConfig.HIGHLIGHTS_COLOURS,
    icon: AppAssets.icons.highlight,
    label: "Highlight",
    subOptionsProperty: "HIGHLIGHTS_COLOURS",
    marks: marks
  }), /*#__PURE__*/React__default.createElement(TextAlignButton, {
    readOnly: readOnly,
    alignment: "left",
    icon: AppAssets.icons.alignLeft,
    label: "Align Left",
    currentAlignment: alignment
  }), /*#__PURE__*/React__default.createElement(TextAlignButton, {
    readOnly: readOnly,
    alignment: "center",
    icon: AppAssets.icons.alignCenter,
    label: "Align Center",
    currentAlignment: alignment
  }), /*#__PURE__*/React__default.createElement(TextAlignButton, {
    readOnly: readOnly,
    alignment: "right",
    icon: AppAssets.icons.alignRight,
    label: "Align Right",
    currentAlignment: alignment
  }), /*#__PURE__*/React__default.createElement(BlockButton, {
    readOnly: readOnly,
    format: "heading-one",
    icon: AppAssets.icons.heading1,
    label: "Headline 1",
    blockType: blockType
  }), /*#__PURE__*/React__default.createElement(BlockButton, {
    readOnly: readOnly,
    format: "heading-two",
    icon: AppAssets.icons.heading2,
    label: "Headline 2",
    blockType: blockType
  }), /*#__PURE__*/React__default.createElement(BlockButton, {
    readOnly: readOnly,
    format: "block-quote",
    icon: AppAssets.icons.quote,
    label: "Quote",
    blockType: blockType
  }), /*#__PURE__*/React__default.createElement(BlockButton, {
    readOnly: readOnly,
    format: "numbered-list",
    icon: AppAssets.icons.ol,
    label: "Numbered List",
    blockType: blockType
  }), /*#__PURE__*/React__default.createElement(BlockButton, {
    readOnly: readOnly,
    format: "bulleted-list",
    icon: AppAssets.icons.ul,
    label: "Bulleted List",
    blockType: blockType
  }), Dimensions.get("window").width > 600 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LinkButton, {
    readOnly: readOnly,
    label: "Insert Link"
  }), /*#__PURE__*/React__default.createElement(RemoveLinkButton, {
    readOnly: readOnly,
    label: "Remove Link"
  })), allowImages && /*#__PURE__*/React__default.createElement(ImageButton, {
    S3uploadUrlRequest: S3uploadUrlRequest,
    setFileUploadInProgress: setFileUploadInProgress,
    setImageFileNameUploadProgress: setImageFileNameUploadProgress,
    imageFileNameUploadProgress: imageFileNameUploadProgress,
    setFileUploadProgress: setFileUploadProgress,
    label: "Insert Image",
    workspaceid: workspaceid
  })), /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "row",
      alignItems: "center"
    }
  }, agcEnabled && acgShownInFixedTitle !== true && /*#__PURE__*/React__default.createElement(ACG, {
    fakeCheckInProgress: fakeCheckInProgress,
    agcEnabled: agcEnabled,
    handleCheckOnFakeData: handleCheckOnFakeData,
    fakeCheckData: fakeCheckData
  }), allowTranscription && /*#__PURE__*/React__default.createElement(RECORDER, {
    allowTranscription: allowTranscription,
    onRecordClick: onRecordClick
  })));
};
AppQuantumEditorToolbar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumEditorToolbar"
};

// import inlineAnnotation from "../Annotation/inlineAnnotation";

const AppQuantumEditorIntentToolbar = _ref => {
  let {
    loggedUser,
    editor,
    isAIEnabled,
    setAIEnabled
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const _styles = styleGenerator$1();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openedItem, setOpenedItem] = useState(null);
  const [tEntities, setTEntities] = useState([]);
  const entityID = useMemo(() => openedItem === null || openedItem === void 0 ? void 0 : openedItem.id, [openedItem]);
  const handleOptionPress = id => {
  };
  useEffect(() => {
    setTEntities(editor === null || editor === void 0 ? void 0 : editor.filter((s, i) => {
      var _s$Constants$INTENT_P;
      return (_s$Constants$INTENT_P = s[QuantumConfig.INTENT_PROPERTY]) === null || _s$Constants$INTENT_P === void 0 ? void 0 : _s$Constants$INTENT_P.map(int => int === null || int === void 0 ? void 0 : int.name).includes(entityID);
    }));
  }, [entityID, editor]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppFadeView, {
    style: _styles.container
  }, /*#__PURE__*/React__default.createElement(View, {
    style: _styles.container
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    color: currentTheme.theme[isAIEnabled ? "green" : "red"],
    isClickable: true,
    onPress: () => setAIEnabled(!isAIEnabled),
    icon: AppAssets.icons.ai,
    style: {
      marginRight: 20
    }
  }), tickableEvents.map((b, i) => {
    var _editor$filter;
    return /*#__PURE__*/React__default.createElement(AppLabelCountIcon, {
      onPress: () => {
        setIsModalOpen(!isModalOpen);
        setOpenedItem(b);
      },
      labelCountIconViewStyle: _styles.leaf,
      isDescriptionVisible: false,
      label: b.label,
      icon: b.ticked_icon,
      count: editor === null || editor === void 0 ? void 0 : (_editor$filter = editor.filter((s, i) => {
        var _s$Constants$INTENT_P2;
        return (_s$Constants$INTENT_P2 = s[QuantumConfig.INTENT_PROPERTY]) === null || _s$Constants$INTENT_P2 === void 0 ? void 0 : _s$Constants$INTENT_P2.map(int => int === null || int === void 0 ? void 0 : int.name).includes(b.id);
      })) === null || _editor$filter === void 0 ? void 0 : _editor$filter.length,
      key: b.label
    });
  })), /*#__PURE__*/React__default.createElement(AppPopup, {
    onPopupShow: () => {},
    icon: AppAssets.icons.option,
    popupTitle: "Options",
    placement: "left"
  }, /*#__PURE__*/React__default.createElement(AppMenuOptions, {
    onChange: options => {
    },
    onOptionPressed: id => handleOptionPress(),
    options: QuantumConfig.INTENT_TOOLBAR_OPTIONS
  }))), /*#__PURE__*/React__default.createElement(AppModal, {
    modalStyle: _styles.modalStyle,
    animationType: "slide",
    rightIconSize: 20,
    isAppIconLeftAvailable: false,
    barTitleStyle: {
      paddingRight: 20
    },
    modalTitle: openedItem === null || openedItem === void 0 ? void 0 : openedItem.label,
    modalWrapperStyle: {
      margin: "auto"
    },
    transparent: true,
    isModalVisible: isModalOpen,
    modalInnerContentStyle: {
      paddingTop: 0,
      margin: (tEntities === null || tEntities === void 0 ? void 0 : tEntities.length) === 0 && "auto"
    },
    isCloseButtonVisible: true,
    closeModal: () => setIsModalOpen(false),
    modalBackdropStatic: false
  }, (tEntities === null || tEntities === void 0 ? void 0 : tEntities.length) > 0 ? tEntities === null || tEntities === void 0 ? void 0 : tEntities.map((s, i) => /*#__PURE__*/React__default.createElement(AppQuantumAutoNLPBlock, {
    key: i,
    element: s,
    children: Node.string(s),
    loggedUser: loggedUser
  })) : /*#__PURE__*/React__default.createElement(AppPlaceholderView, {
    mainCaption: "Nothing to report here",
    size: "1x",
    subCaption: "Create your first ".concat(openedItem === null || openedItem === void 0 ? void 0 : openedItem.label, " to see results here"),
    icon: AppAssets.icons.orbit,
    wrapperStyle: {
      width: 200,
      height: 200
    }
  })));
};
const styleGenerator$1 = props => {
  return StyleSheet.create({
    modalStyle: {
      margin: "auto",
      minHeight: 300,
      minWidth: Platform.OS !== "web" ? "90%" : 400,
      flexGrow: 0,
      borderRadius: 10,
      alignItems: "center",
      justifyContent: "center"
    },
    container: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      flex: "inherit",
      overflowX: "auto"
    },
    leaf: {
      marginRight: 25
    }
  });
};
AppQuantumEditorIntentToolbar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumEditorIntentToolbar"
};

// import inlineAnnotation from "../Annotation/inlineAnnotation";

const QuantumAnnotationToolBar = _ref => {
  let {
    handleAnnotation,
    isContextualAdditionEnabled = false,
    isDisabled
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const {
    NERStyles
  } = useQuantumEditor();
  const _styles = styleGenerator(currentTheme, (NERStyles === null || NERStyles === void 0 ? void 0 : NERStyles.length) > 0);
  const editor = useSlate();
  const _nerIconsList = useMemo(() => {
    var _NERStyles$sort;
    return NERStyles === null || NERStyles === void 0 ? void 0 : (_NERStyles$sort = NERStyles.sort((a, b) => a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1)) === null || _NERStyles$sort === void 0 ? void 0 : _NERStyles$sort.map(b => {
      var _editor$selection, _editor$selection$anc, _editor$selection2, _editor$selection2$fo, _editor$children$, _currentTheme$theme;
      return /*#__PURE__*/React__default.createElement(AppLabelCountIcon, {
        labelCountIconViewStyle: {
          paddingHorizontal: 3
        },
        descriptionLabelStyle: {
          maxWidth: "100%",
          alignSelf: "center"
        },
        descriptionLabelWrapperStyle: {
          maxWidth: 44
        },
        borderWrapperRadius: 10,
        paddingWrapper: 5,
        minWidth: 50,
        wrapperWidth: 50,
        marginRight: 10,
        marginLeft: 10,
        tooltip: "".concat(b === null || b === void 0 ? void 0 : b.label).concat(b !== null && b !== void 0 && b.description ? ": ".concat(b === null || b === void 0 ? void 0 : b.description) : "", " "),
        isDisabled: ((editor === null || editor === void 0 ? void 0 : (_editor$selection = editor.selection) === null || _editor$selection === void 0 ? void 0 : (_editor$selection$anc = _editor$selection.anchor) === null || _editor$selection$anc === void 0 ? void 0 : _editor$selection$anc.path[0]) === 0 || (editor === null || editor === void 0 ? void 0 : (_editor$selection2 = editor.selection) === null || _editor$selection2 === void 0 ? void 0 : (_editor$selection2$fo = _editor$selection2.focus) === null || _editor$selection2$fo === void 0 ? void 0 : _editor$selection2$fo.path[0]) === 0) && ((_editor$children$ = editor.children[0]) === null || _editor$children$ === void 0 ? void 0 : _editor$children$.type) === "title" || isDisabled,
        isEmoji: true,
        backgroundColor: b.backgroundColor,
        descriptionLabelColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.white,
        label: b.label,
        fontSize: 11,
        labelStyle: {
          fontSize: 32
        },
        icon: b.emoji || b.icon,
        onPress: isDisabled ? () => {} : handleAnnotation,
        data: [],
        key: b.label,
        height: 20,
        width: 50
      });
    });
  }, [JSON.stringify(NERStyles), isDisabled, editor]);
  return /*#__PURE__*/React__default.createElement(AppFadeView, {
    style: _styles.container
  }, isContextualAdditionEnabled && /*#__PURE__*/React__default.createElement(AnnotationToolBarAddIcon, {
    isEmoji: true
  }), _nerIconsList);
};
const styleGenerator = (props, isPopulated) => {
  return StyleSheet.create({
    container: {
      display: "flex",
      flexDirection: "row",
      overflowX: "auto",
      overflowY: "hidden",
      zIndex: "initial",
      marginBottom: isPopulated && 35,
      paddingVertical: isPopulated && 5
    }
  });
};
QuantumAnnotationToolBar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "QuantumAnnotationToolBar",
  "props": {
    "isContextualAdditionEnabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};

const initialValue = [{
  children: [{
    text: "Document title"
  }],
  type: "title"
}, {
  children: [{
    text: ""
  }]
}];

const withEditableVoids = editor => {
  const {
    isVoid
  } = editor;
  editor.isVoid = element => {
    return element.type === "editable-void" ? true : isVoid(element);
  };
  return editor;
};

function withGeneration(editor) {
  editor.appendText = _ref => {
    let {
      text,
      at
    } = _ref;
    Transforms.insertText(editor, text, {
      at
    });
  };
  return editor;
}

const ELEMENT_TAGS = {
  A: el => ({
    type: "link",
    url: el.getAttribute("href")
  }),
  BLOCKQUOTE: () => ({
    type: "quote"
  }),
  H1: () => ({
    type: "heading-one"
  }),
  H2: () => ({
    type: "heading-two"
  }),
  H3: () => ({
    type: "heading-three"
  }),
  H4: () => ({
    type: "heading-four"
  }),
  H5: () => ({
    type: "heading-five"
  }),
  H6: () => ({
    type: "heading-six"
  }),
  IMG: el => ({
    type: "image",
    url: el.getAttribute("src")
  }),
  LI: () => ({
    type: "list-item"
  }),
  OL: () => ({
    type: "numbered-list"
  }),
  P: () => ({
    type: "paragraph"
  }),
  PRE: () => ({
    type: "code"
  }),
  UL: () => ({
    type: "bulleted-list"
  })
};

// COMPAT: `B` is omitted here because Google Docs uses `<b>` in weird ways.
const TEXT_TAGS = {
  CODE: () => ({
    code: true
  }),
  DEL: () => ({
    strikethrough: true
  }),
  EM: () => ({
    italic: true
  }),
  I: () => ({
    italic: true
  }),
  S: () => ({
    strikethrough: true
  }),
  STRONG: () => ({
    bold: true
  }),
  U: () => ({
    underline: true
  }),
  MARK: () => ({}),
  B: () => ({
    bold: true
  }),
  SPAN: () => ({})
};
const deserialize = el => {
  if (el.nodeType === 3) {
    return el.textContent;
  } else if (el.nodeType !== 1) {
    return null;
  } else if (el.nodeName === "BR") {
    return "\n";
  }
  const {
    nodeName
  } = el;
  let parent = el;
  if (nodeName === "PRE" && el.childNodes[0] && el.childNodes[0].nodeName === "CODE") {
    parent = el.childNodes[0];
  }
  let children = Array.from(parent.childNodes).map(deserialize).flat();
  if (children.length === 0) {
    children = [{
      text: ""
    }];
  }
  if (el.nodeName === "BODY") {
    return jsx("fragment", {}, children);
  }
  if (ELEMENT_TAGS[nodeName]) {
    const attrs = ELEMENT_TAGS[nodeName](el);
    return jsx("element", attrs, children);
  }
  if (TEXT_TAGS[nodeName]) {
    let attrs = TEXT_TAGS[nodeName](el);
    // extract "data-tooltip" attribute from <mark> tag
    if (nodeName === "MARK") {
      const tooltip = el.getAttribute("data-tooltip");
      if (tooltip) {
        attrs = {
          ...attrs,
          type: "__ner__",
          [tooltip]: true
        };
      }
      if (el.getAttribute("data-highlight-color")) attrs = {
        ...attrs,
        ["highlight".concat(el.getAttribute("data-highlight-color").charAt(0).toUpperCase() + el.getAttribute("data-highlight-color").slice(1))]: true
      };
    } else if (nodeName === "SPAN" && el.getAttribute("data-font-color")) {
      attrs = {
        ...attrs,
        ["font".concat(el.getAttribute("data-font-color").charAt(0).toUpperCase() + el.getAttribute("data-font-color").slice(1))]: true
      };
    }
    return children.map(child => {
      var _child;
      if (((_child = child) === null || _child === void 0 ? void 0 : _child.type) === "link" && Array.isArray(child.children)) {
        let text = "";
        child.children.forEach(c => {
          text += c.text;
        });
        child = text;
      }
      return jsx("text", attrs, child);
    });
  }
  return children;
};
const withHtml = editor => {
  const {
    insertData,
    isInline,
    isVoid
  } = editor;
  editor.isInline = element => {
    return element.type === "link" ? true : isInline(element);
  };
  editor.isVoid = element => {
    return element.type === "image" ? true : isVoid(element);
  };
  editor.insertData = data => {
    const html = data.getData("text/html");
    if (html) {
      const parsed = new DOMParser().parseFromString(html, "text/html");
      const fragment = deserialize(parsed.body);
      Transforms.insertFragment(editor, fragment);
      return;
    }
    insertData(data);
  };
  return editor;
};

const withMentions = editor => {
  const {
    isInline,
    isVoid
  } = editor;
  editor.isInline = element => {
    return QuantumConfig.META_TARGETS.map(e => e.id).includes(element.type) ? true : isInline(element);
  };
  editor.isVoid = element => {
    return QuantumConfig.META_TARGETS.map(e => e.id).includes(element.type) ? true : isVoid(element);
  };
  return editor;
};
const insertMention = (editor, character, metaTarget) => {
  Transforms.insertNodes(editor, {
    character,
    children: [{
      text: ""
    }],
    type: metaTarget
  });
  Transforms.move(editor);
};

function withSingleLine(editor) {
  const {
    normalizeNode
  } = editor;
  editor.normalizeNode = _ref => {
    let [node, path] = _ref;
    if (path.length === 0) {
      if (editor.children.length > 1) {
        Transforms.mergeNodes(editor);
      }
    }
    return normalizeNode([node, path]);
  };
  return editor;
}

const withTables = editor => {
  const {
    deleteBackward,
    deleteForward,
    insertBreak
  } = editor;
  editor.deleteBackward = unit => {
    const {
      selection
    } = editor;
    if (selection && Range.isCollapsed(selection)) {
      const [cell] = Editor.nodes(editor, {
        match: n => !Editor.isEditor(n) && Element$1.isElement(n) && n.type === "table-cell"
      });
      if (cell) {
        const [, cellPath] = cell;
        const start = Editor.start(editor, cellPath);
        if (Point.equals(selection.anchor, start)) {
          return;
        }
      }
    }
    deleteBackward(unit);
  };
  editor.deleteForward = unit => {
    const {
      selection
    } = editor;
    if (selection && Range.isCollapsed(selection)) {
      const [cell] = Editor.nodes(editor, {
        match: n => !Editor.isEditor(n) && Element$1.isElement(n) && n.type === "table-cell"
      });
      if (cell) {
        const [, cellPath] = cell;
        const end = Editor.end(editor, cellPath);
        if (Point.equals(selection.anchor, end)) {
          return;
        }
      }
    }
    deleteForward(unit);
  };
  editor.insertBreak = () => {
    const {
      selection
    } = editor;
    if (selection) {
      const [table] = Editor.nodes(editor, {
        match: n => !Editor.isEditor(n) && Element$1.isElement(n) && n.type === "table"
      });
      if (table) {
        return;
      }
    }
    insertBreak();
  };
  return editor;
};

const withLayout = editor => {
  const {
    normalizeNode
  } = editor;
  editor.normalizeNode = _ref => {
    let [node, path] = _ref;
    if (path.length === 0) {
      if (editor.children.length < 1) {
        const title = {
          type: "title",
          children: [{
            text: "No title"
          }]
        };
        Transforms.insertNodes(editor, title, {
          at: path.concat(0)
        });
      }
      if (editor.children.length < 2) {
        const paragraph = {
          type: "paragraph",
          children: [{
            text: ""
          }]
        };
        Transforms.insertNodes(editor, paragraph, {
          at: path.concat(1)
        });
      }
      for (const [child, childPath] of Node.children(editor, path)) {
        const type = childPath[0] === 0 ? "title" : "paragraph";
        if (Element$1.isElement(child) && child.type !== type) {
          if (childPath[0] === 0) {
            const newProperties = {
              type
            };
            Transforms.setNodes(editor, newProperties, {
              at: childPath
            });
          } else if (childPath[0] !== 0 && child.type === "title") {
            const newProperties = {
              type
            };
            Transforms.setNodes(editor, newProperties, {
              at: childPath
            });
          }
        }
      }
    }
    return normalizeNode([node, path]);
  };
  return editor;
};

const AppQuantumEditor = _ref => {
  var _currentTheme$theme14;
  let {
    editMode,
    value = initialValue,
    setValue = () => {},
    setEditor = () => {},
    trainMode,
    answerMode,
    trainAnswerMode,
    trainGenerationMode,
    baseDocumentRedirectLink,
    autoAnalysisMode,
    forceTitle,
    isToolBarVisible,
    isNERToolBarVisible = true,
    isNERToolBarDisabled = false,
    isTitleEditable = true,
    isGenerationMode = true,
    acgShownInFixedTitle = false,
    nlpSecret,
    baseUrl,
    loggedUser,
    availableUsers = mocked_data.namesData,
    availableTags = mocked_data.tagsData,
    hotKeysEnabled = false,
    isIntentToolBarVisibile,
    isHTMLPastingAllowed = false,
    readOnly,
    searchString,
    isSingleLine,
    allowRichHtml = true,
    allowImages = true,
    isAIEnabled,
    setAIEnabled,
    titleStyle,
    lastUpdateDate,
    nlpConfig,
    NERStyles,
    IntentStyles,
    documentId,
    idToken,
    username,
    style,
    onSocketConnectionChange = () => {},
    onSocketSyncChange = () => {},
    websocketEndpoint,
    fakeCheckData,
    fakeCheckInProgress,
    handleCheckOnFakeData = () => {},
    agcEnabled = false,
    parseMode,
    placeholder,
    fixedTitleWrapperStyle,
    fixedTitleStyle,
    fixedTitle,
    sharedType,
    rtcProvider,
    fixedPlaceholderStyle,
    fixedPlaceholder,
    belowLinePlaceholder,
    showPlaceholderUnderLine,
    isPlaceHolderEnabled,
    isLineByLinePlaceHolderEnabled,
    onError = () => {},
    maxCharacters = 15000,
    maxWords = 2500,
    characters = 0,
    words = 0,
    showCounter = true,
    handleAddDictionary = () => {},
    showContentLengthSlider,
    fixedTitleContainerWrapperStyle,
    minimumOutputContentValue = 300,
    maximumOutputContentValue = 1600,
    handleContentLenghtChange = () => {},
    maxOutputContentLength = 800,
    rtcEditor,
    allowTranscription,
    onRecordClick = () => {},
    S3uploadUrlRequest = () => {},
    S3downloadUrlRequest = () => {},
    workspaceid,
    autoFocus = false,
    trainingContentType = "gn"
  } = _ref;
  const handleAnnotation = useCallback(ner => {
    try {
      insertNER(editor, ner);
    } catch (error) {
      onError({
        message: error.message,
        type: "error"
      });
    }
  }, [editor, insertNER]);
  const {
    currentTheme
  } = useTheme();
  const ref = useRef();
  // Needed for mentions
  const [search, setSearch] = useState("");
  const [metaTarget, setMetaTarget] = useState(null);
  const [target, setTarget] = useState();
  const [index, setIndex] = useState(0);
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
  const [isMounted, setIsMounted] = useState(false);
  const [marks, setMarks] = useState([]);
  const [alignment, setAlignment] = useState("");
  const [blockType, setBlockType] = useState("");
  const [cursors, setCursors] = useState([]);
  const [fileUploadInProgress, setFileUploadInProgress] = useState(0);
  const [imageFileNameUploadProgress, setImageFileNameUploadProgress] = useState(null);
  const [fileUploadProgress, setFileUploadProgress] = useState(0);
  const safeEventKeys = ["altKey", "ctrlKey", "metaKey", "shiftKey", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight", "Backspace", "Delete", "Escape", "Tab", "Home", "End", "PageUp", "PageDown", "Meta"];
  const renderElement = useCallback(props => /*#__PURE__*/React__default.createElement(Element, _extends({
    isTitleEditable: isTitleEditable,
    isAIEnabled: isAIEnabled,
    trainMode: trainMode,
    answerMode: answerMode,
    parseMode: parseMode,
    autoAnalysisMode: autoAnalysisMode,
    nlpSecret: nlpSecret,
    baseUrl: baseUrl,
    loggedUser: loggedUser,
    titleStyle: titleStyle,
    lastUpdateDate: lastUpdateDate,
    readOnly: readOnly,
    isPlaceHolderEnabled: isPlaceHolderEnabled,
    isLineByLinePlaceHolderEnabled: isLineByLinePlaceHolderEnabled,
    baseDocumentRedirectLink: baseDocumentRedirectLink,
    trainAnswerMode: trainAnswerMode,
    trainGenerationMode: trainGenerationMode,
    trainingContentType: trainingContentType,
    S3downloadUrlRequest: S3downloadUrlRequest,
    workspaceid: workspaceid,
    fileUploadInProgress: fileUploadInProgress,
    imageFileNameUploadProgress: imageFileNameUploadProgress,
    fileUploadProgress: fileUploadProgress
  }, props)), [trainMode, parseMode, readOnly, trainAnswerMode, trainGenerationMode, workspaceid, fileUploadInProgress, imageFileNameUploadProgress, fileUploadProgress, trainingContentType]);
  const renderLeaf = useCallback(props => {
    if (props.leaf.placeholder && showPlaceholderUnderLine) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Leaf, props), /*#__PURE__*/React__default.createElement("span", {
        style: {
          opacity: 0.3,
          position: "absolute"
        },
        contentEditable: false
      }, belowLinePlaceholder));
    }
    return /*#__PURE__*/React__default.createElement(Leaf, _extends({}, props, {
      NERStyles: NERStyles,
      readOnly: readOnly
    }));
  }, [NERStyles, readOnly]);
  useEffect(() => {
    if (editMode && documentId && rtcProvider) {
      rtcProvider.on("status", value => {
        // onSocketConnectionChange(status);
      });
      const color = randomColor();
      rtcProvider.awareness.setLocalState({
        alphaColor: alpha(color, 0.5),
        color,
        name: username
      });

      // rtcProvider.on("synced", (isSynced) => {
      //   console.log("synced", isSynced, Date.now());
      //   // onSocketSyncChange(isSynced);
      // });

      // rtcProvider.on("close"),
      //   (event) => {
      //     console.log("close", event, Date.now());
      //     onSocketConnectionChange("disconnected");
      //   };

      // rtcProvider.on("disconnect"),
      //   (event) => {
      //     console.log("disconnect", event, Date.now());
      //     onSocketConnectionChange("disconnected");
      //   };

      rtcProvider.connect();
      return () => {
        rtcProvider.disconnect();
        rtcProvider.awareness.setLocalState(null);
      };
    }
  }, [editMode, rtcProvider, username]);
  const editor = useMemo(() => {
    let baseEditor = rtcEditor || createEditor();
    let _editor = withNER(withLinks(withMentions(withHistory(withReact(baseEditor)))));
    if (allowRichHtml) _editor = withTables(withHtml(_editor));
    if (forceTitle) _editor = withLayout(_editor);
    if (allowImages) _editor = withImages(_editor);
    if (isSingleLine) _editor = withSingleLine(_editor);
    if (trainAnswerMode || trainGenerationMode) _editor = withEditableVoids(_editor);
    if (isGenerationMode) _editor = withGeneration(_editor);
    // Ensure editor always has at least 1 valid child
    const {
      normalizeNode
    } = _editor;
    _editor.normalizeNode = entry => {
      const [node] = entry;
      if (!Editor.isEditor(node) || node.children.length > 0) {
        return normalizeNode(entry);
      }

      // Transforms.insertNodes(
      //   editor,
      //   {
      //     type: "paragraph",
      //     children: [{ text: "" }],
      //   },
      //   { at: [0] }
      // );
    };

    return _editor;
  }, [forceTitle, allowRichHtml, isSingleLine, sharedType, rtcProvider === null || rtcProvider === void 0 ? void 0 : rtcProvider.document, documentId, rtcEditor]);
  const chars = autoCompleteOptions.filter(c => c.toLowerCase().startsWith(search.toLowerCase())).slice(0, 10);
  const onKeyDown = useCallback(event => {
    if (target) {
      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          const prevIndex = index >= chars.length - 1 ? 0 : index + 1;
          setIndex(prevIndex);
          break;
        case "ArrowUp":
          event.preventDefault();
          const nextIndex = index <= 0 ? chars.length - 1 : index - 1;
          setIndex(nextIndex);
          break;
        case "Tab":
        case "Enter":
          event.preventDefault();
          Transforms.select(editor, target);
          insertMention(editor, chars[index], metaTarget);
          setTarget(null);
          break;
        case "Escape":
          event.preventDefault();
          setTarget(null);
          break;
      }
    }
  }, [index, search, target]);
  useEffect(() => {
    if (editor && !isMounted) {
      setIsMounted(true);
      setEditor(editor);
    }
  }, [editor]);
  const handleOnChange = value => {
    setValue(value);
    setEditor(editor);
    const {
      selection
    } = editor;
    delayedMarksExtraction(editor, setMarks);
    delayedAlignmentExtraction(editor, setAlignment, setBlockType);
    if (hotKeysEnabled && selection && Range.isCollapsed(selection)) {
      try {
        const [start] = Range.edges(selection);
        const wordBefore = Editor.before(editor, start, {
          unit: "word"
        });
        const before = wordBefore && Editor.before(editor, wordBefore);
        const beforeRange = before && Editor.range(editor, before, start);
        const beforeText = beforeRange && Editor.string(editor, beforeRange);
        const beforeMatch = beforeText && beforeText.match(/^@(\w+)$/);
        const beforeMatchTag = beforeText && beforeText.match(/^#(\w+)$/);
        const after = Editor.after(editor, start);
        const afterRange = Editor.range(editor, start, after);
        const afterText = Editor.string(editor, afterRange);
        const afterMatch = afterText.match(/^(\s|$)/);
        if ((beforeMatch || beforeMatchTag) && afterMatch) {
          if (beforeMatch) {
            setMetaTarget("MENTION");
            setSearch(beforeMatch[1]);
          } else if (beforeMatchTag) {
            setMetaTarget("TAG");
            setSearch(beforeMatchTag[1]);
          }
          setTarget(beforeRange);
          setIndex(0);
          return;
        }
      } catch (error) {
        console.error("The selection appears inconsistent with the editor state");
      }
    } else if (target !== null) setTarget(null);
  };
  const decorate = useCallback(_ref2 => {
    let [node, path] = _ref2;
    const ranges = [];
    if (searchString && Text.isText(node)) {
      const {
        text
      } = node;
      const parts = text.split(searchString);
      let offset = 0;
      parts.forEach((part, i) => {
        if (i !== 0) {
          ranges.push({
            anchor: {
              path,
              offset: offset - searchString.length
            },
            focus: {
              path,
              offset
            },
            highlight: true
          });
        }
        offset = offset + part.length + searchString.length;
      });
    }
    if (editor.selection != null) {
      if (!Editor.isEditor(node) && Editor.string(editor, [path[0]]) === "" && Range.includes(editor.selection, path) && Range.isCollapsed(editor.selection)) {
        return [{
          ...editor.selection,
          placeholder: true
        }];
      }
    }
    if (Text.isText(node) && cursors !== null && cursors !== void 0 && cursors.length) {
      cursors === null || cursors === void 0 ? void 0 : cursors.forEach(cursor => {
        if (Range.includes(cursor, path)) {
          try {
            const {
              focus,
              anchor,
              data
            } = cursor;
            const isFocusNode = Path.equals(focus.path, path);
            const isAnchorNode = Path.equals(anchor.path, path);
            const isForward = Range.isForward({
              anchor,
              focus
            });
            ranges.push({
              data,
              isForward,
              isCaret: isFocusNode,
              anchor: {
                path,
                // eslint-disable-next-line no-nested-ternary
                offset: isAnchorNode ? anchor.offset : isForward ? 0 : node.text.length
              },
              focus: {
                path,
                // eslint-disable-next-line no-nested-ternary
                offset: isFocusNode ? focus.offset : isForward ? node.text.length : 0
              }
            });
          } catch (e) {
            console.error(e);
          }
        }
      });
    }
    return ranges;
  }, [searchString, cursors]);
  useEffect(() => {
    if (hotKeysEnabled && target && chars.length > 0) {
      const el = ref.current;
      const domRange = ReactEditor.toDOMRange(editor, target);
      const rect = domRange.getBoundingClientRect();
      el.style.top = "".concat(rect.top + window.pageYOffset + 24, "px");
      el.style.left = "".concat(rect.left + window.pageXOffset, "px");
    }
  }, [chars.length, editor, index, search, target]);
  useEffect(() => {
    if (hotKeysEnabled && QuantumConfig.META_TARGETS.map(u => u.id).includes(metaTarget)) switch (metaTarget) {
      case "MENTION":
        setAutoCompleteOptions(availableUsers);
        break;
      case "TAG":
        setAutoCompleteOptions(availableTags);
        break;
      default:
        setAutoCompleteOptions([]);
        break;
    }
  }, [metaTarget, availableUsers, availableTags]);
  const extractMarksFromEditor = (editor, setMarks) => {
    var _Object$keys;
    const _marks = Editor.marks(editor);
    setMarks(!_marks || ((_Object$keys = Object.keys(_marks)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0 ? null : _marks);
  };
  const delayedMarksExtraction = useRef(debounce$1((editor, setMarks) => {
    extractMarksFromEditor(editor, setMarks);
  }, QuantumConfig.MARKS_EXTRACTION_TIMER)).current;
  const isTextAlignedDebounced = (editor, setAlignment, setBlockType) => {
    const selectedBlock = Utilities.extractOnSelection(editor);
    if (selectedBlock) {
      var _selectedBlock$, _selectedBlock$2;
      setAlignment((_selectedBlock$ = selectedBlock[0]) === null || _selectedBlock$ === void 0 ? void 0 : _selectedBlock$.textAlign);
      setBlockType((_selectedBlock$2 = selectedBlock[0]) === null || _selectedBlock$2 === void 0 ? void 0 : _selectedBlock$2.type);
    }
  };
  const delayedAlignmentExtraction = useRef(debounce$1((editor, setAlignment, setBlockType) => {
    isTextAlignedDebounced(editor, setAlignment, setBlockType);
  }, QuantumConfig.MARKS_EXTRACTION_TIMER)).current;
  const returnCleanList = u => {
    const cleanedList = [];
    u.forEach(item => {
      if (item.type === "list-item" || item.type === "paragraph") {
        cleanedList.push(...item.children.filter((v, i) => v.type));
      }
    });
    return cleanedList;
  };
  useCallback(fragment => {
    const _cleanedFragments = fragment.filter(u => {
      var _u$children, _u$children$, _u$children$2, _u$, _u$2, _u$children2;
      return u.type && (u === null || u === void 0 ? void 0 : (_u$children = u.children) === null || _u$children === void 0 ? void 0 : _u$children.length) > 0 && (u === null || u === void 0 ? void 0 : (_u$children$ = u.children[0]) === null || _u$children$ === void 0 ? void 0 : _u$children$.text) && (u === null || u === void 0 ? void 0 : (_u$children$2 = u.children[0]) === null || _u$children$2 === void 0 ? void 0 : _u$children$2.text) !== "\n" || (u === null || u === void 0 ? void 0 : u.text) && (u === null || u === void 0 ? void 0 : u.text) !== "\n" || (u === null || u === void 0 ? void 0 : u.length) > 0 && ((_u$ = u[0]) === null || _u$ === void 0 ? void 0 : _u$.text) && ((_u$2 = u[0]) === null || _u$2 === void 0 ? void 0 : _u$2.text) !== "\n" || ((u === null || u === void 0 ? void 0 : u.type) === "numbered-list" || (u === null || u === void 0 ? void 0 : u.type) === "bulleted-list") && (u === null || u === void 0 ? void 0 : (_u$children2 = u.children) === null || _u$children2 === void 0 ? void 0 : _u$children2.length) !== 0;
    });
    return _cleanedFragments.map(u => {
      if (u.type === "bulleted-list" || u.type === "numbered-list") {
        const _children = u.children.filter(v => v.type);
        if (_children.length !== 0) return {
          type: u.type,
          children: returnCleanList(u === null || u === void 0 ? void 0 : u.children)
        };
      } else {
        return u;
      }
    });
  }, []);
  const handleOnPaste = useCallback(event => {
    try {
      let text = event.clipboardData.getData("text/plain");
      if (!text || text === "" || (text === null || text === void 0 ? void 0 : text.trim()) === "" || text === "\n") {
        event.preventDefault();
        event.stopPropagation();
        return onError({
          message: "Cannot paste empty content or an image from clipboard",
          type: "error"
        });
      }
      if ((text === null || text === void 0 ? void 0 : text.trim().length) > 0 && Utilities.charactesCount(text.toString()) > maxCharacters - (characters || 0) || Utilities.wordsCount(text.toString()) > maxWords - (words || 0)) {
        onError({
          message: "Cannot paste content as it exceeds the maximum words and/or characters",
          type: "error"
        });
        event.preventDefault();
        event.stopPropagation();
      }
    } catch (error) {
      onError({
        message: "A generic error occured while pasting content - ".concat(error),
        type: "error"
      });
    }
  }, [maxCharacters, maxWords, words, characters]);
  const _toolbar = useMemo(() => {
    return /*#__PURE__*/React__default.createElement(AppQuantumEditorToolbar, {
      marks: marks,
      alignment: alignment,
      blockType: blockType,
      readOnly: readOnly,
      agcEnabled: agcEnabled,
      handleCheckOnFakeData: handleCheckOnFakeData,
      fakeCheckData: fakeCheckData,
      acgShownInFixedTitle: acgShownInFixedTitle,
      fakeCheckInProgress: fakeCheckInProgress,
      allowTranscription: allowTranscription,
      onRecordClick: onRecordClick,
      allowImages: allowImages,
      S3uploadUrlRequest: S3uploadUrlRequest,
      fileUploadInProgress: fileUploadInProgress,
      setFileUploadInProgress: setFileUploadInProgress,
      setImageFileNameUploadProgress: setImageFileNameUploadProgress,
      imageFileNameUploadProgress: imageFileNameUploadProgress,
      setFileUploadProgress: setFileUploadProgress,
      workspaceid: workspaceid
    });
  }, [marks, alignment, blockType, readOnly, acgShownInFixedTitle, fakeCheckInProgress, fakeCheckData, allowTranscription, onRecordClick, allowImages, S3uploadUrlRequest, fileUploadInProgress, setFileUploadInProgress, setImageFileNameUploadProgress, imageFileNameUploadProgress, setFileUploadProgress, workspaceid]);
  const handleAddQnA = useCallback(function (label, event) {
    var _editor$children, _editor$children2;
    let isSyS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let isDPO = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    event.preventDefault();
    const {
      selection
    } = editor;
    const text = {
      text: ""
    };
    const voidNode = {
      type: "editable-void",
      is_conversational: true,
      ROLE: isSyS ? "system" : "user",
      IS_SYSTEM: isSyS,
      children: [text]
    };
    if (isSyS) Transforms.insertNodes(editor, voidNode, {
      at: [1]
    });else if (isDPO) {
      const lastIndex = editor.children.length - 1;
      editor.children[lastIndex];
      const dpoNode = {
        type: "editable-void",
        is_conversational: true,
        ROLE: "assistant",
        IS_SYSTEM: false,
        IS_DPO: true,
        children: [{
          text: ""
        }]
      };
      Transforms.insertNodes(editor, dpoNode, {
        at: [lastIndex]
      });
    } else Transforms.insertNodes(editor, voidNode);
    if ((editor === null || editor === void 0 ? void 0 : (_editor$children = editor.children[selection.focus.path[0] + 2]) === null || _editor$children === void 0 ? void 0 : _editor$children.type) === "editable-void" || (editor === null || editor === void 0 ? void 0 : (_editor$children2 = editor.children) === null || _editor$children2 === void 0 ? void 0 : _editor$children2.length) === selection.focus.path[0] + 2) {
      const textNode = {
        type: "paragraph",
        children: [text]
      };
      Transforms.insertNodes(editor, textNode);
    }
  }, [editor, trainingContentType]);
  const _trainAnswerToolbar = useMemo(() => {
    var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5, _currentTheme$theme6, _currentTheme$theme7, _currentTheme$theme8, _currentTheme$theme9, _currentTheme$theme10, _currentTheme$theme11, _currentTheme$theme12, _currentTheme$theme13;
    return /*#__PURE__*/React__default.createElement(View, {
      style: {
        width: "fit-content",
        paddingBottom: 20,
        zIndex: 100,
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React__default.createElement(View, {
      style: {
        flexDirection: "row",
        alignItems: "center",
        gap: 5
      }
    }, /*#__PURE__*/React__default.createElement(AppLabelCountIcon, {
      labelCountIconViewStyle: {
        borderRadius: 0,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        paddingVertical: 5
      },
      borderWrapperRadius: 5,
      popableViewStyle: {
        marginLeft: 40
      },
      descriptionLabelWrapperStyle: {
        width: "100%",
        textAlign: "center",
        justifyContent: "center"
      },
      descriptionLabelColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.font_color,
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.orange,
      label: "ADD SYS",
      labelStyle: {
        fontSize: 16
      },
      data: [],
      icon: AppAssets.icons.trainAI,
      onPress: (label, event) => {
        if (value) {
          const IS_SYSTEM_PRESENT = value === null || value === void 0 ? void 0 : value.find(u => u === null || u === void 0 ? void 0 : u.IS_SYSTEM);
          if (IS_SYSTEM_PRESENT) {
            return onError({
              message: "There is already a system block in the document. You can only add one system block per document.",
              type: "error"
            });
          } else {
            handleAddQnA(label, event, true);
          }
        }
      },
      height: 40,
      width: 48,
      borderRadius: 0,
      activeColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.font_color,
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.font_color,
      tooltip: "Add the system prompt to the conversation"
    }), /*#__PURE__*/React__default.createElement(AppLabelCountIcon, {
      labelCountIconViewStyle: {
        borderRadius: 0,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        paddingVertical: 5
      },
      borderWrapperRadius: 5,
      popableViewStyle: {
        marginLeft: 40
      },
      descriptionLabelWrapperStyle: {
        width: "100%",
        textAlign: "center",
        justifyContent: "center"
      },
      descriptionLabelColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.font_color,
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.primary,
      label: "ADD TURN",
      labelStyle: {
        fontSize: 16
      },
      data: [],
      icon: AppAssets.icons.plus,
      onPress: handleAddQnA,
      height: 40,
      width: 48,
      borderRadius: 0,
      activeColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.font_color,
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.font_color,
      tooltip: "Add a turn to the conversation"
    }), trainingContentType == "gn" && /*#__PURE__*/React__default.createElement(AppLabelCountIcon, {
      labelCountIconViewStyle: {
        borderRadius: 0,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        paddingVertical: 5
      },
      borderWrapperRadius: 5,
      popableViewStyle: {
        marginLeft: 40
      },
      descriptionLabelWrapperStyle: {
        width: "100%",
        textAlign: "center",
        justifyContent: "center"
      },
      descriptionLabelColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme9 = currentTheme.theme) === null || _currentTheme$theme9 === void 0 ? void 0 : _currentTheme$theme9.font_color,
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme10 = currentTheme.theme) === null || _currentTheme$theme10 === void 0 ? void 0 : _currentTheme$theme10.purple,
      label: "ADD DPO",
      labelStyle: {
        fontSize: 16
      },
      data: [],
      icon: AppAssets.icons.preference,
      onPress: (label, event) => {
        if (value) {
          const IS_DPO_PRESENT = value === null || value === void 0 ? void 0 : value.find(u => u === null || u === void 0 ? void 0 : u.IS_DPO);
          if (IS_DPO_PRESENT) {
            return onError({
              message: "There is already a DPO block in the document. You can only add one DPO block per document.",
              type: "error"
            });
          } else {
            handleAddQnA(label, event, false, true);
          }
        }
      },
      height: 40,
      width: 48,
      borderRadius: 0,
      activeColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme11 = currentTheme.theme) === null || _currentTheme$theme11 === void 0 ? void 0 : _currentTheme$theme11.font_color,
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme12 = currentTheme.theme) === null || _currentTheme$theme12 === void 0 ? void 0 : _currentTheme$theme12.font_color,
      tooltip: "Add the preference optimisation snippet"
    })), /*#__PURE__*/React__default.createElement(AppText, {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme13 = currentTheme.theme) === null || _currentTheme$theme13 === void 0 ? void 0 : _currentTheme$theme13.primary,
      wrapperStyle: {
        marginHorizontal: 10,
        maxWidth: "70%"
      },
      style: {
        fontWeight: "bold",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap"
      }
    }));
  }, [trainingContentType, trainGenerationMode, handleAddQnA, handleAddDictionary, currentTheme]);
  const _nerToolbar = useMemo(() => {
    return /*#__PURE__*/React__default.createElement(QuantumAnnotationToolBar, {
      isDisabled: isNERToolBarDisabled || readOnly,
      handleAnnotation: handleAnnotation
    });
  }, [isNERToolBarDisabled, handleAnnotation, readOnly, isNERToolBarVisible]);
  const handleKeyDown = event => {
    const {
      selection
    } = editor;
    if ((maxCharacters || maxWords) && selection && Range.isCollapsed(selection) && !safeEventKeys.includes(event.key) && !(event !== null && event !== void 0 && event.metaKey)) {
      if (maxCharacters <= characters) {
        event.preventDefault();
        event.stopPropagation();
        return onError({
          message: "Reached the maximum number of characters allowed",
          type: "error"
        });
      }
      if (maxWords <= words) {
        event.preventDefault();
        event.stopPropagation();
        return onError({
          message: "Reached the maximum number of words allowed",
          type: "error"
        });
      }
    }
    for (const hotkey in QuantumConfig.HOTKEYS) {
      if (isHotkey(hotkey, event)) {
        event.preventDefault();
        const mark = QuantumConfig.HOTKEYS[hotkey];
        Utilities.toggleMark(editor, mark);
        break;
      }
    }
    if (hotKeysEnabled) {
      onKeyDown(event);
    }
  };
  return /*#__PURE__*/React__default.createElement(QuantumEditorProvider, {
    onChange: setValue,
    editorState: value,
    rawEditorState: editor,
    isAIEnabled: isAIEnabled,
    NERStyles: NERStyles,
    IntentStyles: IntentStyles,
    nlpConfig: nlpConfig
  }, /*#__PURE__*/React__default.createElement(Slate, {
    editor: editor,
    value: value,
    onChange: value => {
      handleOnChange(value);
    }
  }, isToolBarVisible && _toolbar, isNERToolBarVisible && _nerToolbar, (trainAnswerMode || trainGenerationMode) && _trainAnswerToolbar, isIntentToolBarVisibile && /*#__PURE__*/React__default.createElement(AppQuantumEditorIntentToolbar, {
    editor: editor.children,
    loggedUser: loggedUser,
    isAIEnabled: isAIEnabled,
    setAIEnabled: setAIEnabled
  }), fixedTitle && /*#__PURE__*/React__default.createElement(View, {
    style: [{
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center"
    }, fixedTitleContainerWrapperStyle]
  }, /*#__PURE__*/React__default.createElement(AppText, {
    wrapperStyle: [{
      marginBottom: 0,
      marginTop: 0,
      marginRight: 20,
      flex: 1
    }, fixedTitleWrapperStyle],
    style: [{
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme14 = currentTheme.theme) === null || _currentTheme$theme14 === void 0 ? void 0 : _currentTheme$theme14.base_font_size,
      fontWeight: "bold"
    }, fixedTitleStyle]
    // size={currentTheme?.theme?.medium_font_size}
  }, fixedTitle), showContentLengthSlider && /*#__PURE__*/React__default.createElement(AppTrackSlider, {
    wrapperStyle: {
      marginRight: 20,
      position: "relative",
      top: 10
    },
    unitLabel: "",
    value: maxOutputContentLength,
    onValueChange: v => handleContentLenghtChange(v),
    minimumValue: minimumOutputContentValue,
    maximumValue: maximumOutputContentValue,
    step: 50,
    showValue: true,
    valueLabel: "Output tokens"
  }), agcEnabled && acgShownInFixedTitle && /*#__PURE__*/React__default.createElement(ACG, {
    agcEnabled: agcEnabled,
    fakeCheckData: fakeCheckData,
    handleCheckOnFakeData: handleCheckOnFakeData,
    fakeCheckInProgress: fakeCheckInProgress
  })), (rtcProvider === null || rtcProvider === void 0 ? void 0 : rtcProvider.wsconnected) === false ? /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "column",
      alignSelf: "center",
      alignItems: "center",
      flex: 1
    }
  }, /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "column",
      alignSelf: "center",
      alignItems: "center",
      height: 200,
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement(AppActivityIndicator, {
    visible: true,
    containerStyle: {
      flex: 0.5
    }
  }), /*#__PURE__*/React__default.createElement(AppText, {
    fontWeight: "bold"
  }, "Attempting to connect..."), (rtcProvider === null || rtcProvider === void 0 ? void 0 : rtcProvider.wsUnsuccessfulReconnects) > 10 && /*#__PURE__*/React__default.createElement(AppText, null, "Please check your internet connection and try again."))) : rtcEditor && !fileUploadInProgress ? /*#__PURE__*/React__default.createElement(QuantumEditable, {
    setCursors: setCursors,
    style: style,
    editor: editor,
    decorate: decorate,
    readOnly: readOnly,
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    placeholder: placeholder || "Type away some text…",
    spellCheck: true,
    autoFocus: autoFocus,
    className: "qEditor",
    onPaste: event => {
      handleOnPaste(event);
    },
    onKeyDown: handleKeyDown
  }) : /*#__PURE__*/React__default.createElement(Editable, {
    style: style,
    editor: editor,
    decorate: decorate,
    readOnly: readOnly,
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    placeholder: placeholder || "Type away some text…",
    spellCheck: true,
    autoFocus: autoFocus,
    className: "qEditor",
    onPaste: event => {
      handleOnPaste(event);
    },
    onKeyDown: handleKeyDown
  }), hotKeysEnabled && target && chars.length > 0 && /*#__PURE__*/React__default.createElement(QuantumAutoCompletionPortal, {
    ref: ref,
    chars: chars,
    index: index
  }), (cursors === null || cursors === void 0 ? void 0 : cursors.length) > 0 && /*#__PURE__*/React__default.createElement(AppAvatarList, {
    avatarSize: 18,
    avatarRatio: 0.5,
    wrapperStyle: {
      position: "absolute",
      right: 10,
      bottom: 10
    },
    namesList: cursors === null || cursors === void 0 ? void 0 : cursors.map(u => {
      var _u$data, _u$data2;
      return {
        label: u === null || u === void 0 ? void 0 : (_u$data = u.data) === null || _u$data === void 0 ? void 0 : _u$data.name,
        color: u === null || u === void 0 ? void 0 : (_u$data2 = u.data) === null || _u$data2 === void 0 ? void 0 : _u$data2.color
      };
    })
  }), !readOnly && showCounter && /*#__PURE__*/React__default.createElement(AppQuantumCounter, {
    words: words,
    maxWords: maxWords,
    characters: characters,
    maxCharacters: maxCharacters
  })));
};
AppQuantumEditor.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumEditor",
  "props": {
    "value": {
      "defaultValue": {
        "value": "initialValue",
        "computed": true
      },
      "required": false
    },
    "setValue": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "setEditor": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "isNERToolBarVisible": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "isNERToolBarDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "isTitleEditable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "isGenerationMode": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "acgShownInFixedTitle": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "availableUsers": {
      "defaultValue": {
        "value": "mocked_data.namesData",
        "computed": true
      },
      "required": false
    },
    "availableTags": {
      "defaultValue": {
        "value": "mocked_data.tagsData",
        "computed": true
      },
      "required": false
    },
    "hotKeysEnabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "isHTMLPastingAllowed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "allowRichHtml": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "allowImages": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "onSocketConnectionChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onSocketSyncChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "handleCheckOnFakeData": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "agcEnabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "onError": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "maxCharacters": {
      "defaultValue": {
        "value": "15000",
        "computed": false
      },
      "required": false
    },
    "maxWords": {
      "defaultValue": {
        "value": "2500",
        "computed": false
      },
      "required": false
    },
    "characters": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "required": false
    },
    "words": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "required": false
    },
    "showCounter": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "handleAddDictionary": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "minimumOutputContentValue": {
      "defaultValue": {
        "value": "300",
        "computed": false
      },
      "required": false
    },
    "maximumOutputContentValue": {
      "defaultValue": {
        "value": "1600",
        "computed": false
      },
      "required": false
    },
    "handleContentLenghtChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "maxOutputContentLength": {
      "defaultValue": {
        "value": "800",
        "computed": false
      },
      "required": false
    },
    "onRecordClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "S3uploadUrlRequest": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "S3downloadUrlRequest": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "autoFocus": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "trainingContentType": {
      "defaultValue": {
        "value": "\"gn\"",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppQuantumEditor as default };
